import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Link, useHistory, useParams, Redirect } from 'react-router-dom';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { useFormik } from 'formik';
import { RadioGroup, FormControlLabel, FormLabel, FormControl, MenuItem, InputLabel, Checkbox } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { useSelector } from 'react-redux';
import _ from "lodash";
import AuthoritySearch from './AuthoritySearch';
//components
import TextInput from '../../shared/Fields/TextInput';
import CheckBox from '../../shared/Fields/CheckBox';
import SelectBox from '../../shared/Fields/SelectBox';
import DropDownBox from '../../shared/Fields/DropDownBox';
import DatePicker from '../../shared/Fields/DatePicker';
import RadioButton from '../../shared/Fields/RadioButton';
import { getSeqSearchInit, submitSeqSearch, saveTemplate } from '../../services/seqSearchService';
import SavedSearch from '../../services/savedsearch';
import FolderTreeStructure from '../../shared/FolderTreeStructure/FolderTreeStructure';
import SeqVIModal from '../../shared/Modal/SeqVIModal';
import ContactSupportErrorModal from '../../shared/Modal/ContactSupportErrorModal';
//validation
import Validate from '../../helpers/validate';
import { handleDecimalInput } from '../../helpers/inputValidation';
import { containerWidth } from '../../shared/constants';
import { calculateMaxMismatches, shouldDisplayMismatchText as checkMismatchDisplay, countSequences } from '../../helpers/mismatchCalculator';
//service
import AccountInfo from '../../services/accountInfo';
import Tooltip from "@material-ui/core/Tooltip";

const toolTipStyles = {
    tooltip: {
        width: "auto",
        //height: "40px",
        fontSize: '12px',
        textAlign: 'justify',
        padding: "8px 14px 8px 14px",
        boxShadow: "0px 1px 7px #888",
        backgroundColor: '#777',
        color: '#FFF'
    }
};
const CustomTooltip = withStyles(toolTipStyles)(Tooltip);

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
        maxWidth: containerWidth,
        margin: '0 auto 28px',
        minHeight: '260px',
        borderBottom: '1px solid #cec7c7',
        padding: '23px 13px 5px'
    },
    checkboxEnabled: {
        color: "rgb(174, 169, 169) !important", // when enabled
    },
    checkboxDisabled: {
        color: "rgb(78 78 78) !important", // when disabled
    },  
    arrowIcon: {
        fontSize: '2.5rem',
        marginTop: '-2px',
        marginLeft: '-10px'
    },
    arrowIconTitle: {
        marginLeft: '-8px'
    },
    seqText: {
        margin: '10px 0'
    },
    smallTextBox: {
        width: "60px"
    },
    marginRightCancel: {
        marginRight: "10px"
    },
    checkBoxContent: {
        fontSize: "14px",
        // width: "100%",
        textAlign: "initial",
        marginLeft: "10px",
        marginBottom: "5px !important",
        marginTop: "4px"
    },
    checkBox: {
        margin: "auto",
        width: "20px",
        height: "20px"
    },
    theseAreText: {
        margin: "9px 20px 10px 0px"
    },
    submitCss: {
        backgroundColor: "#DB862D !important"
    },
    dbError: {
        // textAlign: "center",
        fontStyle: "italic"
    },
    loginSubmitCancel: {
        backgroundColor: '#0182C5',
        borderColor: '#1F4E79',
        border: '1px solid #1F4E79',
        color: 'white',
        margin: "4px",
        float: 'right',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#0182C5',
            boxShadow: 'none',
        },
    },
    // mediumSizedTextBox: {
    //     width: "19%"
    // },
    rowElementsContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    rowElementsContainerDark: {
        display: 'flex',
        alignItems: 'center', 
       // background: '#292929',
    },
    row1: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        "& #minResidues-helper-text": {
            marginLeft: "-25px"
        }
    },
    numberInput: {
        width: '80px'
    },
    // '@media (min-width: 768px)': {
    //     desktopHelpLink: {
    //         display: 'block'
    //     },
    //     mobileHelpLink: {
    //         display: 'none'
    //     }
    // },
    // '@media (max-width: 760px)': {
    //     desktopHelpLink: {
    //         display: 'none'
    //     },
    //     mobileHelpLink: {
    //         display: 'block'
    //     },
    //     arrowIcon: {
    //         fontSize: '2.5rem',
    //         marginTop: '-2px',
    //         marginLeft: '-10px'
    //     },
    //     arrowIconTitle: {
    //         marginLeft: '-8px'
    //     }
    // }
    // '@media (min-width: 768px)': {
    //     desktopHelpLink: {
    //         display: 'block'
    //     },
    //     mobileHelpLink: {
    //         display: 'none'
    //     }
    // },
    '@media (min-width: 900px)': {
        blastMargin: {
            marginLeft: "211px"
        },
        processHsps: {
            marginLeft: "168px"
        }
    }

}));

const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        minHeight: 30,
        width: '102%',
        margin: 0,
        //backgroundColor: '#292929',
        '&$expanded': {
            minHeight: 30,
            margin: 0,
            //backgroundColor: '#292929',
        },
    },
    content: {
        margin: '0',
       // backgroundColor: '#292929',
        '&$expanded': {
            margin: '0',
            //backgroundColor: '#292929'
        },
    },
    expanded: {},
    // '@media (max-width: 780px)': {
    //     root: {
    //         width: '100%',
    //     }
    // }
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: '0 0 0 5px',
        margin: '0',
        display: 'block',
        //backgroundColor: '#292929'
    },
}))(MuiAccordionDetails);
const data = [
    {
        name: "GQ-Pat Gold Plus Protein - Patent Sequences",
        result: "pass"
    },
    {
        name: "GQ-Pat Platinum Protein - Patent Sequences",
        result: "pass"
    },
    {
        name: "CAS BiosequencesTM - Proteins from Patents",
        result: "pass"
    },
    {
        name: "GENESEQ Protein Sequences",
        result: "pass"
    },

];
const data1 = [
    {
        name: "GQ-Pat Gold Plus Nucleotide – Patent Sequences",
        result: "pass"
    },
    {
        name: "GQ-Pat Platinum Nucleotide – Patent Sequences",
        result: "pass"
    },
    {
        name: "CAS BiosequencesTM - Nucleotide from Patents",
        result: "pass"
    },
    {
        name: "GENESEQ Nucleotide Sequences",
        result: "pass"
    },

];
const data2 = [
    {
        name: "Ref Seq mRNA Sequences",
        result: "pass"
    },
    {
        name: "ENSEMBL mRNA Sequences",
        result: "pass"
    },
    {
        name: "PDB Nucleotide Sequences",
        result: "pass"
    },
    {
        name: "CAS BioSequencesTM - Journals and Proceedings",
        result: "pass"
    },

];
const data3 = [
    {
        name: "PDB Protein Sequences",
        result: "pass"
    },
    {
        name: "GenPept Translated GenBank",
        result: "pass"
    },
    {
        name: "ENSEMBL Protein Sequences",
        result: "pass"
    },
    {
        name: "CAS BioSequencesTM - Journals and Proceedings",
        result: "pass"
    },
    {
        name: "SwissProt from Expasy",
        result: "pass"
    },
    {
        name: "Ref Seq Protein Sequences",
        result: "pass"
    },
    {
        name: "Translated EMBL from Expasy",
        result: "pass"
    },

];
const defaultDbPattern = ["Patent sequences","Geneseq - Nucleotide sequences","- Nucleotides from Patents"];
const defaultDbPatternPro = ["Patent sequences","Geneseq - Protein sequences","- Proteins from Patents"];


function IpSeqSearch(props) {
    const { t, i18n } = useTranslation('common');
    const history = useHistory();

    const classes = useStyles();

    //using state
    const userInfo = useSelector(state => state.setUserInfo);

    const { parentId } = useParams();
    const { tempname } = useParams();



    const [seqDBFilter, setSeqDBFilter] = React.useState(true);
    const [specificDBFilter, setSpecificDBFilter] = React.useState(true);
    const maxResidues = '100,000';

    const [formCheck1, setformCheck1] = React.useState(true);
    const [formCheck2, setformCheck2] = React.useState(true);
    const [formCheck3, setformCheck3] = React.useState(true);
    const [formCheck4, setformCheck4] = React.useState(true);
    const [formCheck5, setformCheck5] = React.useState(false);
    const [formCheck6, setformCheck6] = React.useState(false);
    const [formCheck7, setformCheck7] = React.useState(false);
    const [formCheck8, setformCheck8] = React.useState(false);
    const [formCheck9, setformCheck9] = React.useState(false);

    const [allChecked, setAllChecked] = useState(false);
    // using an array to store the checked items
    const [proPatentData, setProPatentData] = useState([]);
    const [proReferenceData, setProReferenceData] = useState([]);
    const [proPersonalData, setProPersonalData] = useState({});
    const [proSharedData, setProSharedData] = useState({});

    const [nucPatentData, setNucPatentData] = useState([]);
    const [nucReferenceData, setNucReferenceData] = useState([]);
    const [nucPersonalData, setNucPersonalData] = useState({});
    const [nucSharedData, setNucSharedData] = useState({});

    const [searchAlgorithmValue, setSearchAlgorithm] = useState("kerr");
    const [scoringMatrixValue, setScoringMatrix] = useState("NUC.3.1");
    const [sequenceTypeValue, setSequenceType] = useState("nucleotide");
    const [frameTypeValue, setFrameType] = useState("both");
    const [wordSizeValue, setWordSize] = useState("11");
    const [nucleotideData, setNucleotideData] = useState();
    const [proteinData, setProteinData] = useState();
    const [files, setFiles] = useState([]);
    // const [querySequenceValue, setQuerySequencyValue] = useState();
    const [genePastValue, setGenePastValue] = useState("QUERY");
    const [personalDataValue, setPersonalDataValue] = useState();
    const [isBothDbSelected, setIsBothDbSelected] = useState(false);
    const [dbTypeArray, setDbTypeArray] = useState([]);
    const [sendMailAfterSearch, setSendMailAfterSearch] = useState(false);
    const [defaultsave, setDefaultSave] = useState(false);
    const [processHsp, setProcessHsp] = useState(true);
    const [nucDb, setNucDb] = useState([]);
    const [proDb, setProDb] = useState([]);
    const [saveFormValue, setSaveFormValue] = useState(false);
    const [isDocPubDate, setIsDocPubDate] = useState(false);
    const [isEarliestPriorityDate, setIsEarliestPriorityDate] = useState(false);
    const [isPublished, setIsPublished] = useState(false);
    const [isPatientDoc, setIsPatientDoc] = useState(false);
    const [isPatentAuth, setIsPatentAuth] = useState(false);
    const [sdbFilters, setSdbFilters] = useState([]);
    const [ppuType, setPpuType] = useState();
    const [isSubmitActive, setIsSubmitActive] = useState(true);
    const [isDocPubUnknownDates, setIsDocPubUnknownDates] = useState(false);
    const [isEarliestPriorityUnknownDates, setIsEarliestPriorityUnknownDates] = useState(false);
    const [ispublishGQUnknownDates, setIspublishGQUnknownDates] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState();
    const [nucGenBankData, setNucGenBankData] = useState([]);
    const [userClassName, setUserClassName] = useState();
    const [accGroupName, setAccGroupName] = useState('');
    const [credits, setCredits] = useState(0);
    const [groupVoucherCredits, setGroupVoucherCredits] = useState(0);
    const [voucherCreditsToUse, setVoucherCreditsToUse] = useState(0);
    const [useSubQuery, setUseSubQuery] = useState(false);
    const [subQueries, setSubQueries] = useState([]);
    const [calculateCredit, setcCalculateCredit] = useState();
    const [systemControlSubmit, setSystemControlSubmit] = useState(true);
    const redoInitCalledRef = useRef(false);
    const [showCreditCalC, setShowCreditCalc] = useState(false);
    const [systemControlSubmitText, setSystemControlSubmitText] = useState('');
    const [isUserData, setIsUserData] = useState(false);
    const [noDbSelected, setNoDbSelected] = useState(false);
    const [noPatentAuthValue, setNoPatentAuthValue] = useState(false);
    const [warningMsg, setWarningMsg] = useState("");
    const [isWarningReturned, setIsWarningReturned] = useState(false);
    const [duplicateSeqWarning, setDuplicateSeqWarning] = useState("");
    const [errorHeading, setErrorHeading] = useState("");
    const [formSubmit, setFromSubmit] = useState(false);
    const [expandedNucIds, setExpandedNucIds] = useState();
    const [expandedPrtIds, setExpandedPrtIds] = useState();
    const [expandedNucSharedIds, setExpandedNucSharedIds] = useState();
    const [expandedPrtSharedIds, setExpandedPrtSharedIds] = useState();
    const [selData, setSelData] = useState([]);
    const toggle = useSelector(state => state.setToggle.toggle);
    const [selectedTags, setSelectedTags] = useState([]);
    const [redoPA, setRedoPA] = useState(false);
    const [itemV, setItemV] = useState('');
    const [matchTu, setMatchTu] = useState(true);
    const [createFt, setCreateFt] = useState(false);

    let initialCreditValues = {
        ppu1SubTotal: 0,
        ppu1NucSubTotal: 0,
        ppu1ProSubTotal: 0,
        ppu1Total: 0,
        seqCount: 0,
        ppu2NucCredit: 0,
        ppu2ProCredit: 0,
        ppu2TotalCredit: 0,
        ppu2RemainingCredits: 0
    };
    const [creditValues, setCreditValues] = useState(initialCreditValues);
    let pubFormatted = moment()._d;
    // pubFormatted = moment(pubFormatted).format('MMMM-DD-YYYY')
    let redoInitialObj = {
        searchDetails: `IP ${moment().format('YYYY-MM-DD h:mm:ss')}`,
        querySequence: '',
        alignments: '5000',
        genePastPercentage: '80',
        expectCutoff: '10',
        fragmentStretch: '50',
        fragmentAminoAcid: '96',
        docPublicSel: "BEF",
        earliestPrioritySel: "BEF",
        publishGQSel: "BEF",
        patientDocSel: "LTE",
        docPublicDate: pubFormatted,
        earliestPriorityDate: pubFormatted,
        publishGQDate: pubFormatted,
        genepastPercentageOver: "QUERY",
        patientDocInp: 100000,
        minResidues: '6',
        maxResidues: '100000'
    };
    const [redoInitialState, setRedoInitialState] = useState(redoInitialObj);

    const [preferenceValue, setPreferenceValue] = useState("");
    const [preferenceItems, setPreferenceItems] = useState([]);

    // reset login status
    useEffect(() => {
        // Wait until userInfo is populated so ppuType is known before loading page data.
        if (!userInfo || !userInfo.current_user || Object.keys(userInfo.current_user).length === 0) {
            return;
        }
        (async () => {
            let resp = await getSeqSearchInit(history, null);
            // console.log(   "resp::", resp);
            if (resp && resp.response_content && resp.response_content.search_preferences
                && resp.response_content.search_preferences.length > 0) {
                let items = [];
                for (let item in resp.response_content.search_preferences) {
                    let obj = {};
                    obj.value = resp.response_content.search_preferences[item];
                    obj.label = resp.response_content.search_preferences[item];
                    if (resp.response_content.search_preferences[item] === resp.response_content.default_preference) {
                        obj.label += ' (default)';
                    }
                    items.push(obj);
                }
                setPreferenceItems(items);
            }
            let tempparam;
            if(history.location.pathname === '/ipseqsearch'){
                tempparam = resp?.response_content?.default_preference;
                if(!tempparam){
                    tempparam = 'undefined';
                }
            }else if (history.location.pathname !== '/ipseqsearch' || tempparam === "undefined"){
                tempparam = decodeURI(tempname);
            }
            tempparam = tempparam.toString().replace(/~~GQSF~~/g, '%');
            document.title = 'GenomeQuest - IP Sequence Search';
            if (tempparam && tempparam !== 'undefined' && !parentId) {
                setPreferenceValue(tempparam);
                selectPreference(tempparam);
            }
            let nucmatches =[];
            let promatches =[];
            if (parentId) {
                resp = await getSeqSearchInit(history, parentId);
                if (resp && resp.response_content && resp.response_content.redoParams) {
                    const { nucdbs, protdbs, best_hit_keep_max, nucandprot, qdb_seq, qdb_seq_type, sdb_filters, seqlenrange_high, seqlenrange_low,
                        strat_genepast_perc_id, strat_genepast_perc_id_over, strat_name, title, strat_blast_word_size_nuc, strat_blast_scoring_matrix_nuc,
                        strat_blast_word_size_pro, strat_blast_scoring_matrix_pro, strat_blast_eval_cutoff, strat_blast_hsp, template_name,
                        email, strat_fragment_window_length_nuc, strat_fragment_perc_id_nuc, strat_fragment_window_length_pro,
                        strat_fragment_perc_id_pro, frame_sel, bypass_ft, match_tu, useSubQueries, totalSeqNum } = resp.response_content.redoParams;
                    if (qdb_seq_type) {
                        if (qdb_seq_type === "nucpat") {
                            setSequenceType("nucleotide");
                        } else if (qdb_seq_type === "propat") {
                            setSequenceType("protein");
                        } else {
                            setSequenceType(qdb_seq_type);
                        }
                    } else {
                        setSequenceType("nucleotide");
                    }
                    qdb_seq_type && qdb_seq_type === "protein" && strat_blast_word_size_pro ? setWordSize(strat_blast_word_size_pro) : setWordSize('3');

                    setQueryCount(totalSeqNum);
                    if(useSubQueries === "true"){
                        let test = qdb_seq.trim().split(/[\>]+/);
                        for(let i=0; i<test.length; i++){
                            if(test[i] !== "" && !test[i].startsWith(">")){
                            test[i] = ">"+test[i];
                            }
                        }

                        let nonSubs = test.filter(item => !/_subseq_\d+/.test(item) && item !== "");
                        let subs = test.filter(item => /_subseq_\d+/.test(item) && item !== "");

                        formik.values.querySequence = nonSubs.toString().replaceAll(/[,]+/g, "");
                        setSubQueries(subs);
                        setUseSubQuery(true);
                        calTextCredits(null, isBothDbSelected, 'redo');
                        //HandleSubQuery(formik.values.querySequence);
                    }

                    nucdbs && nucdbs.length > 0 ? setNucDb(nucdbs) : setNucDb([]);
                    protdbs && protdbs.length > 0 ? setProDb(protdbs) : setProDb([]);
                    // When using sub-queries, enforce the same DB restrictions as new searches:
                    // only the matching sequence-type DB is allowed; both-DB is disabled.
                    if (useSubQueries === "true") {
                        if (qdb_seq_type === "protein") {
                            setNucDb([]);
                        } else {
                            setProDb([]);
                        }
                        setIsBothDbSelected(false);
                    } else {
                        nucandprot && nucandprot === "on" ? setIsBothDbSelected(true) : setIsBothDbSelected(false);
                    }
                    redoInitialState.searchDetails = title ? title : "";
                    redoInitialState.querySequence = qdb_seq ? qdb_seq : "";
                    strat_name ? setSearchAlgorithm(strat_name) : setSearchAlgorithm("kerr");
                    redoInitialState.alignments = best_hit_keep_max ? redoInitialState.alignments = best_hit_keep_max : "";
                    redoInitialState.formName = ""; //template_name ? redoInitialState.formName = template_name : "";
                    //template_name ? setSaveFormValue(true) : setSaveFormValue(false);
                    email ? setSendMailAfterSearch(true) : setSendMailAfterSearch(false);
                    redoInitialState.minResidues = seqlenrange_low ? seqlenrange_low : "6";
                    redoInitialState.maxResidues = seqlenrange_high ? seqlenrange_high : "100000";

                    nucmatches = nucdbs.filter(s => s.includes('v:V_') || s.includes('p:LOCAL_'));
                    promatches = protdbs.filter(s => s.includes('v:V_') || s.includes('p:LOCAL_'));
                    //to keep the treeview open when any personal db is selected during redo
                    if(promatches.length > 0){
                        setformCheck6(true);
                        setformCheck8(true);
                    }
                    if(nucmatches.length > 0){
                        setformCheck7(true);
                        setformCheck9(true);
                    }
                    // setRedoInitialState({...redoInitialState});
                    if (strat_name !== 'motif') {
                        const newArray = searchAlgorithmItems.filter((algoValue) => algoValue.value !== 'motif');
                        setSelData(newArray);
                        console.log(selData);
                    } else {
                        const newArray = searchAlgorithmItems.filter((algoValue) => algoValue.value === 'motif');
                        setSelData(newArray);
                    }

                    if (strat_name && (strat_name === "kerr" || strat_name === "hash") && strat_genepast_perc_id && strat_genepast_perc_id_over) {
                        redoInitialState.genePastPercentage = strat_genepast_perc_id;
                        redoInitialState.genepastPercentageOver = strat_genepast_perc_id_over;
                        // setRedoInitialState({...redoInitialState});
                    } else if (strat_name === "blast") {
                        if (qdb_seq_type && qdb_seq_type === "nucleotide" && strat_blast_word_size_nuc && strat_blast_scoring_matrix_nuc) {
                            setWordSize(strat_blast_word_size_nuc);
                            setScoringMatrix(strat_blast_scoring_matrix_nuc);
                        } else if (qdb_seq_type && qdb_seq_type === "protein" && strat_blast_word_size_pro && strat_blast_scoring_matrix_pro) {
                            setWordSize(strat_blast_word_size_pro);
                            setScoringMatrix(strat_blast_scoring_matrix_pro);
                        }
                        redoInitialState.expectCutoff = strat_blast_eval_cutoff ? strat_blast_eval_cutoff : 10;
                        // setRedoInitialState({...redoInitialState});
                        strat_blast_hsp && strat_blast_hsp === "on" ? setProcessHsp(true) : setProcessHsp(false);
                    } else if (strat_name === "fragment") {
                        if (qdb_seq_type && qdb_seq_type === "nucleotide" && strat_fragment_window_length_nuc && strat_fragment_perc_id_nuc) {
                            redoInitialState.fragmentStretch = strat_fragment_window_length_nuc;
                            redoInitialState.fragmentAminoAcid = strat_fragment_perc_id_nuc;
                        } else if (qdb_seq_type && qdb_seq_type === "protein" && strat_fragment_window_length_pro && strat_fragment_perc_id_pro) {
                            redoInitialState.fragmentStretch = strat_fragment_window_length_pro;
                            redoInitialState.fragmentAminoAcid = strat_fragment_perc_id_pro;
                        }
                    }
                    let redoFilters = sdb_filters ? JSON.parse(sdb_filters) : [];
                    redoFilters && redoFilters.length > 0 && redoFilters.map((item, index) => {
                        if (item && item.P && item.P === "SEQUENCE_D1") {
                            redoInitialState.docPublicSel = item.O;
                            redoInitialState.docPublicDate = moment(item.V)._d;
                            setIsDocPubDate(true);
                            if (item.O === "AFT_IE" || item.O === "BEF_IE") {
                                setIsDocPubUnknownDates(true);
                            }
                        } else if (item && item.P && item.P === "SEQUENCE_D4") {
                            redoInitialState.earliestPrioritySel = item.O;
                            redoInitialState.earliestPriorityDate = moment(item.V)._d;
                            setIsEarliestPriorityDate(true);
                            if (item.O === "AFT_IE" || item.O === "BEF_IE") {
                                setIsEarliestPriorityUnknownDates(true);
                            }
                        } else if (item && item.P && item.P === "SEQUENCE_D2") {
                            redoInitialState.publishGQSel = item.O;
                            redoInitialState.publishGQDate = moment(item.V)._d;
                            setIsPublished(true);
                            if (item.O === "AFT_IE" || item.O === "BEF_IE") {
                                setIspublishGQUnknownDates(true);
                            }
                        } else if (item && item.P && item.P === "SEQUENCE_P9") {
                            redoInitialState.patientDocSel = item.O;
                            redoInitialState.patientDocInp = item.V;
                            setIsPatientDoc(true);
                        }
                         else if (item && item.P && item.P === "SEQUENCE_PN") {
                            setRedoPA(true);
                            setItemV(item.V);
                            setIsPatentAuth(true);
                            const countryCodes = item.V.split(',').map(item => item.replace('*', ''));
                            setSelectedTags(countryCodes);
                        }
                        // setRedoInitialState({...redoInitialState});
                    });
                    frame_sel !== undefined ? setFrameType(frame_sel) : setFrameType("both");
                    bypass_ft !== undefined ? setCreateFt(bypass_ft) : setCreateFt(false);
                    match_tu !== undefined ? setMatchTu(match_tu === "1") : setMatchTu(true);
                    setRedoInitialState({ ...redoInitialState });
                    //formik.setValues({ ...redoInitialState }, false);
                }
            }
            // const resp = await getSeqSearchResults(history);
            if (resp && resp.response_content && resp.response_content.sdb_nuc_tree && resp.response_content.sdb_nuc_tree.length > 0) {
                let nucData = resp.response_content.sdb_nuc_tree;
                let nucleotidePatent = [], nucleotideReferenceData = [], nucDataSharedWithMe = [], nucGenBank = [], nucDefaultPatentDb = [], nucMyData = [];
                let nucFormattedData = await list_to_tree(nucData);
                let getNucChild = [];
                if (nucFormattedData && nucFormattedData.length > 0) {
                    getNucChild = nucFormattedData[0].children;
                }
                getNucChild && getNucChild.length > 0 && getNucChild.map((item, index) => {
                    if (item && (item.id === ':Patents' || item.id === ':GqData')) {
                        nucleotidePatent = item.children;
                        item.children.filter(i => {
                            if (defaultDbPattern.some(pattern => i.label.includes(pattern))) {
                                nucDefaultPatentDb.push(i.id);
                            }
                        });
                    } else if (item && item.id === ':Reference Data') {
                        // nucleotideReferenceData = item.children;
                        item.children && item.children.length > 0 && item.children.map((item, index) => {
                            if (item.id.includes("GB_")) {
                                nucGenBank.push(item)
                            } else if (!item.id.includes("GB_")) {
                                nucleotideReferenceData.push(item)
                            }
                        })
                    } else if (item && item.id === ':Data Shared With Me') {
                        nucDataSharedWithMe = item;
                        if(item && _.size(item) > 0 ){
                            setExpandedNucSharedIds(exp(item));
                        }
                    } else if (item && item.id === ':My Data') {
                        nucMyData = item;
                    }
                })
                setNucleotideData(resp.response_content.sdb_nuc_tree);
                setNucPatentData(nucleotidePatent);
                setNucReferenceData(nucleotideReferenceData);
                setNucPersonalData(nucMyData);
                setNucSharedData(nucDataSharedWithMe);
                setNucGenBankData(nucGenBank);
                if (!parentId && !tempname) {
                    setNucDb(nucDefaultPatentDb);
                }          
            }
            let proDefDB26 = [];
            if (resp && resp.response_content && resp.response_content.sdb_pro_tree && resp.response_content.sdb_pro_tree.length > 0) {
                let proteinData = resp.response_content.sdb_pro_tree;
                let proteinPatent = [], proteinReferenceData = [], proDataSharedWithMe = [], proDefaultPatentDb = [], proMyData = [];
                let proFormattedData = await list_to_tree(proteinData);
                let getProChild = [];
                if (proFormattedData && proFormattedData.length > 0) {
                    getProChild = proFormattedData[0].children;
                }
                getProChild && getProChild.length > 0 && getProChild.map((item, index) => {
                    if (item && (item.id === ':Patents' || item.id === ':GqData')) {
                        proteinPatent = item.children;
                        item.children.filter(i => {
                            if (defaultDbPatternPro.some(pattern => i.label.includes(pattern))) {
                                proDefaultPatentDb.push(i.id);
                                proDefDB26.push(i.id);
                            }
                        });
                    } else if (item && item.id === ':Reference Data') {
                        proteinReferenceData = item.children;
                    } else if (item && item.id === ':Data Shared With Me') {
                        proDataSharedWithMe = item;
                        if(item && _.size(item) > 0 ){
                            setExpandedPrtSharedIds(exp(item));
                        }
                    } else if (item && item.id === ':My Data') {
                        proMyData = item;
                    }
                })
                setProteinData(resp.response_content.sdb_pro_tree);
                setProPatentData(proteinPatent);
                setProReferenceData(proteinReferenceData);
                setProPersonalData(proMyData);
                setProSharedData(proDataSharedWithMe);
                // setProDefaultDb(proDefaultPatentDb);
                // setProDb(proDefaultPatentDb);
            }
            let nucIDS = [];
            let proIDS = [];
            if(nucPersonalData && _.size(nucPersonalData) > 0 ){
                nucIDS = exp(nucPersonalData);
                setExpandedNucIds(nucIDS);
            }
            if(proPersonalData && _.size(proPersonalData) > 0 ){
                proIDS = exp(proPersonalData);
                 setExpandedPrtIds(proIDS);
             }
            
            //ST26: if it is redirected from convert sequence page
            if (typeof (props.location.state) !== 'undefined' && props.location.state !== null) {
                // Check if we have separated sequences for protein/nucleotide
                if (props.location.state.proteinSeqs && props.location.state.nucleotideSeqs) {
                    // Use the appropriate sequences based on the type
                    const initialSeq = props.location.state.type === 'nucleotide' 
                        ? props.location.state.nucleotideSeqs 
                        : props.location.state.proteinSeqs;
                    formik.setFieldValue("querySequence", initialSeq);
                } else {
                    // Fallback to original behavior
                    formik.setFieldValue("querySequence", props.location.state.seq);
                }
                
                setSequenceType(props.location.state.type);
                if(props.location.state.type === 'nucleotide'){
                    setProDb([]);
                }
                else{
                    setProDb(proDefDB26);
                    setNucDb([]);
                }
            }

            if (resp && resp.response_content && resp.response_content.group_credits) {
                setCredits(resp.response_content && resp.response_content.group_credits);
                creditValues.ppu2RemainingCredits = resp.response_content.group_credits;
            }

            if (resp && resp.response_content && resp.response_content.group_voucher_credits) {
                setGroupVoucherCredits(resp.response_content.group_voucher_credits);
            }

            if (resp && resp.response_content && resp.response_content.syscontrol_search_submit) {
                setSystemControlSubmit(resp.response_content.syscontrol_search_submit);
            }

            if (resp && resp.response_content && resp.response_content.syscontrol_search_submit_txt) {
                setSystemControlSubmitText(resp.response_content.syscontrol_search_submit_txt);
            }

            // const accountData = await AccountInfo.getAccountInfo();
            // if (accountData && accountData.response_content && accountData.response_content.ppu_type) {
            //     let userPpu = accountData.response_content.ppu_type;
            //     setPpuType(accountData.response_content.ppu_type);
            //     if (userPpu === "1" || userPpu === "2") {
            //         setIsSubmitActive(false);
            //     } else {
            //         setIsSubmitActive(true);
            //     }
            // }
            // setTimeout(() => {
            if (userInfo && userInfo.current_user) {
                let userPpu;
                let currentUser;
                if (Object.keys(userInfo.current_user).length > 0) {
                    userPpu = userInfo.current_user.ppu_type + '';
                    currentUser = userInfo.current_user;
                }
                else{
                    const accountData = await AccountInfo.getAccountInfo();
                    if (accountData && accountData.response_content) { //  && accountData.response_content.ppu_type
                        userPpu = accountData.response_content.ppu_type + '';
                        currentUser = accountData.response_content;
                    }
                }
                setPpuType(userPpu);


                if (currentUser.user_class_name !== "ippreview" && (userPpu === "1" || (userPpu === "2" && !parentId && !currentUser.accounting_group_name.includes('FT - ') && !currentUser.accounting_group_name.includes('SB - '))) || (!setSystemControlSubmit && currentUser.user_class_name !== "adminium")) {
                    setIsSubmitActive(false);

                }
                if ((systemControlSubmit || currentUser.user_class_name === "adminium") && currentUser.user_class_name !== "ippreview" && (userPpu === "1" || (userPpu === "2" && !parentId && !currentUser.accounting_group_name.includes('FT - ') && !currentUser.accounting_group_name.includes('SB - ')))) {
                    setShowCreditCalc(true);
                }

                // if (userPpu === "0") {
                //     setIsSubmitActive(true);
                // } else {
                //     setIsSubmitActive(false);
                // }

                if (userInfo.current_user.user_class_name) {
                    setUserClassName(userInfo.current_user.user_class_name)
                }
                if (userInfo.current_user.accounting_group_name) {
                    setAccGroupName(userInfo.current_user.accounting_group_name)
                }
                setIsUserData(true);
                if (parentId) {
                    calTextCredits(null, isBothDbSelected, 'redo')
                }
                if (typeof (props.location.state) !== 'undefined' && props.location.state !== null) {
                    calTextCredits(null, isBothDbSelected, 'redo')
                }
            }
            // }, 1000);

        })()
    }, [ppuType, userInfo]);

    // Recalculate remaining credits when the user toggles voucher or changes voucher amount
    useEffect(() => {
        if (ppuType === "2") {
            const effectiveVoucher = Math.min(voucherCreditsToUse, creditValues.ppu2TotalCredit);
            const updatedRemaining = credits - creditValues.ppu2TotalCredit + effectiveVoucher;
            setCreditValues(prev => ({ ...prev, ppu2RemainingCredits: updatedRemaining }));
        }
    }, [voucherCreditsToUse]);

    // Sub-queries are billed in sets of 5 in addition to the main sequence, so they count toward the voucher cap too
    const subQueryVoucherCredits = useSubQuery ? Math.floor(subQueries.length / 5) : 0;
    const maxVoucherCredits = Math.min(groupVoucherCredits, creditValues.seqCount + subQueryVoucherCredits);

    useEffect(() => {
        if (voucherCreditsToUse > maxVoucherCredits) {
            setVoucherCreditsToUse(maxVoucherCredits);
        }
    }, [maxVoucherCredits]);

    const handlePreference = (event) => {
        setPreferenceValue(event.target.value);
        selectPreference(event.target.value);
    }

    async function selectPreference(templateName) {

        const dat = await SavedSearch.getParticularTemplate(templateName, 'Sequence');
        if (dat && dat.response_content && dat.response_content.map) {
            const { nucdbs, protdbs, best_hit_keep_max, nucandprot, qdb_seq, qdb_seq_type, sdb_filters, seqlenrange_high, seqlenrange_low,
                strat_genepast_perc_id, strat_genepast_perc_id_over, strat_name, title, strat_blast_word_size_nuc, strat_blast_scoring_matrix_nuc,
                strat_blast_word_size_pro, strat_blast_scoring_matrix_pro, strat_blast_eval_cutoff, strat_blast_hsp, template_name,
                send_email, email, strat_fragment_window_length_nuc, strat_fragment_perc_id_nuc, strat_fragment_window_length_pro,
                strat_fragment_perc_id_pro, frame_sel, bypass_ft, match_tu } = dat.response_content.map;
            //qdb_seq_type ? setSequenceType(qdb_seq_type) : setSequenceType("nucleotide");
            if (qdb_seq_type) {
                if (qdb_seq_type === "nucpat") {
                    setSequenceType("nucleotide");
                } else if (qdb_seq_type === "propat") {
                    setSequenceType("protein");
                } else {
                    setSequenceType(qdb_seq_type);
                }
            } else {
                setSequenceType("nucleotide");
            }

            nucdbs && nucdbs.length > 0 ? setNucDb(nucdbs) : setNucDb([]);
            protdbs && protdbs.length > 0 ? setProDb(protdbs) : setProDb([]);

            // Don't override the values from ST26 parse
            if (typeof (props.location.state) !== 'undefined' && props.location.state !== null) {
                redoInitialState.querySequence = props.location.state.seq;
                setSequenceType(props.location.state.type);

                if (props.location.state.type === 'protein') {
                    proPatentData.filter(i => {
                        if (defaultDbPatternPro.some(pattern => i.label.includes(pattern))) {
                            if (!proDb.includes(i.id)) {
                                proDb.push(i.id);
                            }
                            setProDb([...proDb]);
                        }
                    });
                } else if (props.location.state.type === 'nucloetide') {
                    nucPatentData.filter(i => {
                        if (defaultDbPattern.some(pattern => i.label.includes(pattern))) {
                            if (!nucDb.includes(i.id)) {
                                nucDb.push(i.id);
                            }
                            setNucDb([...nucDb]);
                        }
                    });
                }
            }

            sequenceTypeValue && sequenceTypeValue === "protein" && strat_blast_word_size_pro ? setWordSize(strat_blast_word_size_pro) : setWordSize('3');

            if (sequenceTypeValue && sequenceTypeValue === "protein") {
                setNucDb([]);
            } else if (sequenceTypeValue && sequenceTypeValue === "nucloetide") {
                setProDb([]);
            }
            redoInitialState.searchDetails = title ? title : "";
            //redoInitialState.querySequence = qdb_seq ? qdb_seq : "";
            strat_name ? setSearchAlgorithm(strat_name) : setSearchAlgorithm("kerr");
            redoInitialState.alignments = best_hit_keep_max ? redoInitialState.alignments = best_hit_keep_max : "";
            nucandprot && nucandprot === "on" ? setIsBothDbSelected(true) : setIsBothDbSelected(false);
            //redoInitialState.formName = ""; //template_name ? redoInitialState.formName = template_name : "";
            redoInitialState.formName = templateName;
            //template_name ? setSaveFormValue(true) : setSaveFormValue(false);
            //redoInitialState.sendMailAfterSearch = (send_email === 'on');
            send_email === 'on' ? setSendMailAfterSearch(true) : setSendMailAfterSearch(false);
            redoInitialState.minResidues = seqlenrange_low ? seqlenrange_low : "6";
            redoInitialState.maxResidues = seqlenrange_high ? seqlenrange_high : "100000";

            if (strat_name && (strat_name === "kerr" || strat_name === "hash") && strat_genepast_perc_id && strat_genepast_perc_id_over) {
                redoInitialState.genePastPercentage = strat_genepast_perc_id;
                redoInitialState.genepastPercentageOver = strat_genepast_perc_id_over;
            } else if (strat_name === "blast") {
                if (sequenceTypeValue && sequenceTypeValue === "nucleotide" && strat_blast_word_size_nuc && strat_blast_scoring_matrix_nuc) {
                    setWordSize(strat_blast_word_size_nuc);
                    setScoringMatrix(strat_blast_scoring_matrix_nuc);
                } else if (sequenceTypeValue && sequenceTypeValue === "protein" && strat_blast_word_size_pro && strat_blast_scoring_matrix_pro) {
                    setWordSize(strat_blast_word_size_pro);
                    setScoringMatrix(strat_blast_scoring_matrix_pro);
                }
                redoInitialState.expectCutoff = strat_blast_eval_cutoff ? strat_blast_eval_cutoff : 10;
                strat_blast_hsp && strat_blast_hsp === "on" ? setProcessHsp(true) : setProcessHsp(false);
            } else if (strat_name === "fragment") {
                if (sequenceTypeValue && sequenceTypeValue === "nucleotide" && strat_fragment_window_length_nuc && strat_fragment_perc_id_nuc) {
                    redoInitialState.fragmentStretch = strat_fragment_window_length_nuc;
                    redoInitialState.fragmentAminoAcid = strat_fragment_perc_id_nuc;
                } else if (sequenceTypeValue && sequenceTypeValue === "protein" && strat_fragment_window_length_pro && strat_fragment_perc_id_pro) {
                    redoInitialState.fragmentStretch = strat_fragment_window_length_pro;
                    redoInitialState.fragmentAminoAcid = strat_fragment_perc_id_pro;
                }
            }
            let redoFilters = sdb_filters ? JSON.parse(sdb_filters) : [];
            redoFilters && redoFilters.length > 0 && redoFilters.map((item, index) => {
                if (item && item.P && item.P === "SEQUENCE_D1") {
                    redoInitialState.docPublicSel = item.O;
                    redoInitialState.docPublicDate = moment(item.V)._d;
                    setIsDocPubDate(true);
                    if (item.O === "AFT_IE" || item.O === "BEF_IE") {
                        setIsDocPubUnknownDates(true);
                    }
                } else if (item && item.P && item.P === "SEQUENCE_D4") {
                    redoInitialState.earliestPrioritySel = item.O;
                    redoInitialState.earliestPriorityDate = moment(item.V)._d;
                    setIsEarliestPriorityDate(true);
                    if (item.O === "AFT_IE" || item.O === "BEF_IE") {
                        setIsEarliestPriorityUnknownDates(true);
                    }
                } else if (item && item.P && item.P === "SEQUENCE_D2") {
                    redoInitialState.publishGQSel = item.O;
                    redoInitialState.publishGQDate = moment(item.V)._d;
                    setIsPublished(true);
                    if (item.O === "AFT_IE" || item.O === "BEF_IE") {
                        setIspublishGQUnknownDates(true);
                    }
                } else if (item && item.P && item.P === "SEQUENCE_P9") {
                    redoInitialState.patientDocSel = item.O;
                    redoInitialState.patientDocInp = item.V;
                    setIsPatientDoc(true);
                }
                else if (item && item.P && item.P === "SEQUENCE_PN") {
                    setRedoPA(true);
                    setItemV(item.V);
                    setIsPatentAuth(true);
                    const countryCodes = item.V.split(',').map(item => item.replace('*', ''));
                    setSelectedTags(countryCodes);
                }
            });
            frame_sel !== undefined ? setFrameType(frame_sel) : setFrameType("both");
            bypass_ft !== undefined ? setCreateFt(bypass_ft) : setCreateFt(false);
            match_tu !== undefined ? setMatchTu(match_tu === "1") : setMatchTu(true);
            setRedoInitialState({ ...redoInitialState });
            formik.setValues(redoInitialState);
        }
    }

    const formik = useFormik({
        initialValues: redoInitialState,
        validationSchema: Validate.IpSeqSearchValidate(sequenceTypeValue, saveFormValue, searchAlgorithmValue, isPatientDoc, creditValues),
        onSubmit: async (values) => {
            if ((!(nucDb && nucDb.length > 0) && !(proDb && proDb.length > 0)) //notice the '!'
            //|| (sequenceTypeValue === "nucleotide" && nucDb.length === 0)
            //|| (sequenceTypeValue === "protein" && proDb.length === 0)
            ) {
                setNoDbSelected(true);
                document.getElementById('noDbSelected').scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
                return
            }

            if (isPatentAuth && (!selectedTags || selectedTags.length === 0)) {
                setNoPatentAuthValue(true);
                document.getElementById('isPatentAuth').scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
                return
            }

            let sdbFilterData = [];
            if (isDocPubDate) {
                let docPubStatus;
                if (isDocPubUnknownDates && values.docPublicSel === "BEF") {
                    docPubStatus = "BEF_IE"
                } else if (isDocPubUnknownDates && values.docPublicSel === "AFT") {
                    docPubStatus = "AFT_IE"
                } else {
                    docPubStatus = values.docPublicSel.toString()
                }
                let obj = {
                    "P": "SEQUENCE_D1",
                    "O": docPubStatus,
                    "V": moment(values.docPublicDate).format('YYYYMMDD')
                }
                sdbFilterData.push(obj);
            }
            if (isEarliestPriorityDate) {
                let earliestPriorityStatus;
                if (isEarliestPriorityUnknownDates && values.earliestPrioritySel === "BEF") {
                    earliestPriorityStatus = "BEF_IE"
                } else if (isEarliestPriorityUnknownDates && values.earliestPrioritySel === "AFT") {
                    earliestPriorityStatus = "AFT_IE"
                } else {
                    earliestPriorityStatus = values.earliestPrioritySel.toString()
                }
                let obj = {
                    "P": "SEQUENCE_D4",
                    "O": earliestPriorityStatus,
                    "V": moment(values.earliestPriorityDate).format('YYYYMMDD')
                }
                sdbFilterData.push(obj);
            }
            if (isPublished) {
                let publishedStatus;
                if (ispublishGQUnknownDates && values.docPublicSel === "BEF") {
                    publishedStatus = "BEF_IE"
                } else if (ispublishGQUnknownDates && values.docPublicSel === "AFT") {
                    publishedStatus = "AFT_IE"
                } else {
                    publishedStatus = values.publishGQSel.toString()
                }
                let obj = {
                    "P": "SEQUENCE_D2",
                    "O": publishedStatus,
                    "V": moment(values.publishGQDate).format('YYYYMMDD')
                }
                sdbFilterData.push(obj);
            }
            if (isPatientDoc) {
                let obj = {
                    "P": "SEQUENCE_P9",
                    "O": values.patientDocSel.toString(),
                    "V": values.patientDocInp
                }
                sdbFilterData.push(obj);
            }
            if (isPatentAuth) {

                const result = selectedTags.map(item => item + '*').join(',');
                  
                let obj = {
                    "P": "SEQUENCE_PN",
                    "O": "CT",
                    "V": result
                }
                sdbFilterData.push(obj);
            }
            let userMail = userInfo && userInfo.current_user && userInfo.current_user.email ? userInfo.current_user.email : '';
            let data = {
                qdb_seq: !useSubQuery? values.querySequence : values.querySequence+'\n'+subQueries.toString().replaceAll(/[,]+/g, ""), // query sequence
                qdb_seq_type: sequenceTypeValue, // nucleotide or protein, query sequence type based on the above query seq.
                totalSeqNum: queryCount,
                qdb_id: "", // will have such value for virtual query database, not included in this release yet
                searchtype: "FTO", // leave it as always "FTO"
                stretchLength: useSubQuery? stretchLength+"" : "0",
                useSubQueries: useSubQuery+"",
                title: values.searchDetails.trim(), // Workflow name
                email: sendMailAfterSearch ? userMail : '', // When "Send email when the search is done" is checked, retrieve the email from the user info
                send_email: sendMailAfterSearch ? "on" : "",
                nucandprot: isBothDbSelected ? "on" : "", // "on" when selecting both NUC and PRO databases
                strat_name: searchAlgorithmValue, // Genepast -> kerr, Blast -> blast, Fragment Search -> fragment, Motif -> motif
                frame_sel: currentSelectedValue,
                /*
                strat_sw_scoring_matrix_nuc: "NUC.3.1",
                strat_sw_scoring_matrix_pro: "BLOSUM62",
                strat_sw_gapo_nuc: "1",
                strat_sw_gape_nuc: "1",
                strat_sw_gapo_pro: "1",
                strat_sw_gape_pro: "1",*/
                seqlenrange_low: values.minResidues, // Limit subject length from
                seqlenrange_high: values.maxResidues, // Limit subject length to
                best_hit_keep_max: values.alignments, // Keep a maximum of xxx results
                // sdb_filters example, publication date before 2021/05/27
                //                    & No. of Seq. is less than or equal to 100,000
                //                    & Date of entry before 2021/05/27
                // [{"P":"SEQUENCE_D1","O":"BEF","V":20210527},
                //  {"P":"SEQUENCE_P9","O":"LTE","V":100000},
                //  {"P":"SEQUENCE_D2","O":"BEF","V":20210527}]
                sdb_filters: sdbFilterData && sdbFilterData.length > 0 ? JSON.stringify(sdbFilterData) : "",
                nucdb_type: "multiple", // always multiple
                nucdbs: nucDb,
                // nucdbs: "[\"p:GQPAT_NUC\", \"p:GENA\"]", // string array of databases
                protdb_type: "multiple", // always multiple
                protdbs: proDb, // Similar like nucdbs
                template_name: saveFormValue ? values.formName.trim() : '', // Set this value when selecting "Save this form for later use as"
                is_default: defaultsave,
                parent_id: parentId ? parentId : "", // When having the patent workflow, for the "redo" scenario
                ignore_warning: isWarningReturned ? "1" : "0",
                match_tu: matchTu ? "1" : "0",
                bypass_ft: createFt,
                voucher_credits: voucherCreditsToUse
            };
            if (searchAlgorithmValue === "kerr" || searchAlgorithmValue === "hash") {
                // Genepast parameters
                data.strat_genepast_perc_id = values.genePastPercentage;
                data.strat_genepast_perc_id_over = values.genepastPercentageOver;
            } else if (searchAlgorithmValue === "blast") {
                // Blast
                data.strat_blast_word_size_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? wordSizeValue : "11"; // Word Size - Nucleotide
                data.strat_blast_scoring_matrix_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? scoringMatrixValue : "NUC.3.1"; // Scoring matrix - Nucleotide
                data.strat_blast_word_size_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? wordSizeValue : "3"; // Word Size - Protein
                data.strat_blast_scoring_matrix_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? scoringMatrixValue : "BLOSUM62"; // Scoring matrix - Protein
                data.strat_blast_eval_cutoff = values.expectCutoff; // Expect Cutoff
                data.strat_blast_hsp = processHsp ? "on" : ""; // HSP handling, "on" when the checkbox is selected
            } else if (searchAlgorithmValue === "fragment") {
                // Fragment
                data.strat_fragment_window_length_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? values.fragmentStretch : "50"; // Window Length - Nuc
                data.strat_fragment_perc_id_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? values.fragmentAminoAcid : "96"; // Percentage Identity - Nuc
                data.strat_fragment_window_length_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? values.fragmentStretch : "20"; // Window Length - Prt
                data.strat_fragment_perc_id_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? values.fragmentAminoAcid : "95"; // Percentage Identity - Prt
            } else if (searchAlgorithmValue === "motif") {
                // Set the qdb_seq_type to be nucpat/propat
                if (data.qdb_seq_type === "nucleotide") {
                    data.qdb_seq_type = "nucpat";
                } else {
                    data.qdb_seq_type = "propat";
                }
            }

            let resp = await submitSeqSearch(data, null, t);
            if (resp && resp.response_status === 0) {
                //if(defaultsave){
                    //const apt = await SavedSearch.setDefaultSaved(data.template_name);
                //}
                setShowSuccessModal(true);
                closeSuccessModal();
            } else if (resp && resp.response_status === 2 && resp.response_content.qdb && resp.response_content.qdb.msg && resp.response_content.qdb.msg.includes("wrong query sequence type")) {
                // setWarningMsg("Warning: "+resp.response_content.qdb.msg);
                setIsWarningReturned(true);
                setShowErrorModal(true);
                setErrorMsg("Warning: " + resp.response_content.qdb.msg);
                setErrorHeading('Please notice the warnings below and either fix it or submit as is.')
                // window.scrollTo(0,0);
            } else if (resp && resp.response_status === 1 && resp.response_content.qdb && resp.response_content.qdb.msg) {
                // setWarningMsg("Warning: "+resp.response_content.qdb.msg);
                setShowErrorModal(true);
                setErrorMsg(resp.response_content.qdb.msg);
                setErrorHeading(t("seqSearchErrorOccured"))
                // window.scrollTo(0,0);
            } else {
                let setMessage = resp && resp.response_content && resp.response_content.message ? resp.response_content.message : (resp === 'Error: Network Error') ? 'Network connection failed' : "Unknown";
                // setMessage = resp && resp.response_content && resp.response_content.qdb && resp && resp.response_content && resp.response_content.qdb.msg ? resp.response_content.qdb.msg : "Unknown";
                setShowErrorModal(true);
                setErrorMsg(setMessage);
                setErrorHeading(t("seqSearchErrorOccured"))
                if (resp === 'Error: Network Error') {
                    setTimeout(() => {
                        history.push('/home')
                    }, 5000)
                }
            }
        },
    });

    function list_to_tree(list) {
        var map = {}, node, roots = [], i;

        for (i = 0; i < list.length; i += 1) {
            map[list[i].id] = i; // initialize the map
            list[i].children = []; // initialize the children
        }

        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.parent !== null) {
                // if you have dangling branches check that map[node.parentId] exists
                list[map[node.parent]].children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }

   let pandarr =[];
    function exp(parent) {
        parent.children.forEach(child1 => {
               pandarr.push(child1.parent);
                if(child1.children.length > 0){
                    exp(child1);
                }

        });

        return pandarr;
    }

    function closeSuccessModal() {
        setTimeout(() => {
            setShowSuccessModal(false);
            history.push('/home')
        }, 5000)
    }

    function handleErrorModal() {
        setShowErrorModal(!showErrorModal);
    }

    function closeSaveModal() {
        setShowSuccessModal(false);
        history.push('/home')
    }

    function handleppuCredits(e){
        calTextCredits(e, isBothDbSelected, null);
        let uncheckAgreed = document.getElementById('checkTerms'); //uncheck search fee box when n.o of seq changes for proper fee calc
        if (uncheckAgreed && uncheckAgreed.checked === true) {
            uncheckAgreed.click();
        }
    }

    const handleSearchAlgorithm = (event) => {
        setSearchAlgorithm(event.target.value);
        if(event.target.value !== 'hash'){
            setSubQueries([]);
            setSubQuerySearchError("");
            setSubQueryError("");
            setUseSubQuery(false);
        }
        if (sequenceTypeValue === "nucleotide") {
            setScoringMatrix('NUC.3.1');
            setWordSize('11');
        } else {
            setScoringMatrix('BLOSUM62');
            setWordSize('3');
        }
        if (event.target.value === "motif") {
            setIsBothDbSelected(false);
        }
        if (!matchTu) {
            setFrameType("for"); // When Tu mismatched, only forward mode is supported
        }
    };

    const handleSequenceType = (event) => {
        setSequenceType(event.target.value);
        let queryseqInput = document.getElementById('querySequence');
        queryseqInput.focus(); //to trigger the onblur function to calc ppuFee 
        let uncheckAgreed = document.getElementById('checkTerms');
        if (uncheckAgreed && uncheckAgreed.checked === true) {
            uncheckAgreed.click(); //uncheck the agree checkbox every time the seqtype changes
        }
        
        // Check if we have filtered sequences from ConvertSequenceFasta
        if (typeof (props.location.state) !== 'undefined' && props.location.state !== null && 
            props.location.state.proteinSeqs && props.location.state.nucleotideSeqs) {
            // Use the appropriate filtered sequences based on the selected type
            const filteredSeq = event.target.value === 'nucleotide' 
                ? props.location.state.nucleotideSeqs 
                : props.location.state.proteinSeqs;
            formik.setFieldValue("querySequence", filteredSeq);
        } else {
            formik.setFieldValue("querySequence", queryseqInput.value); // Don't clear the text box values when switching the radio button
        }
        if (!isBothDbSelected) {
            if (event.target.value === "nucleotide") {
                setScoringMatrix('NUC.3.1');
                setWordSize('11');
                formik.setFieldValue("fragmentStretch", '50');
                formik.setFieldValue("fragmentAminoAcid", '96');
                nucPatentData.filter(i => {
                    if (defaultDbPattern.some(pattern => i.label.includes(pattern))) {
                        nucDb.push(i.id);
                        setNucDb([...nucDb]);
                    }
                });
                setProDb([]);
            } else {
                setScoringMatrix('BLOSUM62');
                setWordSize('3');
                formik.setFieldValue("fragmentStretch", '20');
                formik.setFieldValue("fragmentAminoAcid", '95');
                proPatentData.filter(i => {
                    if (defaultDbPatternPro.some(pattern => i.label.includes(pattern))) {
                        proDb.push(i.id);
                        setProDb([...proDb]);
                    }
                });
                // setProDb(proDefaultDb);
                setNucDb([]);
            }
        }

    };

    function handleDbChange(id, name) {

        if (name && name === "nuc") {
            if (nucDb.includes(id)) {
                if (nucDb.length === 1 && proDb.length > 0) {
                    setIsBothDbSelected(false);
                    calTextCredits(null, false, "isCompare");
                }
                setNucDb(nucDb.filter(dbName => dbName !== id));
            } else {
                if (nucDb.length === 0 && proDb.length > 0) {
                    setIsBothDbSelected(true);
                    calTextCredits(null, true, "isCompare");
                }
                nucDb.push(id.toString());
                setNucDb([...nucDb]);
            }
        } else if (name && name === "pro") {
            if (proDb.includes(id)) {
                if (proDb.length === 1 && nucDb.length > 0) {
                    setIsBothDbSelected(false);
                    calTextCredits(null, false, "isCompare");
                }
                setProDb(proDb.filter(dbName => dbName !== id));
            } else {
                if (proDb.length === 0 && nucDb.length > 0) {
                    setIsBothDbSelected(true);
                    calTextCredits(null, true, "isCompare");
                }
                proDb.push(id.toString());
                setProDb([...proDb]);
            }
        }
        setNoDbSelected(false);
    }

    async function handleCompareBothDb(override = false) {
        let type = "isCompare";
        if (isBothDbSelected === true || override === true) {
            setIsBothDbSelected(false);
            calTextCredits(null, false, type);
            sequenceTypeValue === "nucleotide" ? setProDb([]) : setNucDb([]);

        } else {
            setMatchTu(true);
            setFrameType("both");
            setIsBothDbSelected(true);
            setUseSubQuery(false);
            calTextCredits(null, true, type);

            //if (sequenceTypeValue === "nucleotide") {

                proPatentData.filter(i => {
                    if (defaultDbPatternPro.some(pattern => i.label.includes(pattern))) {
                        if(!proDb.includes(i.id)){
                            proDb.push(i.id);
                        }    
                        setProDb([...proDb]);
                    }
                });
            //} else if (sequenceTypeValue === "protein") {
                nucPatentData.filter(i => {
                    if (defaultDbPattern.some(pattern => i.label.includes(pattern))) {
                        if(!nucDb.includes(i.id)){
                            nucDb.push(i.id);
                        }
                        setNucDb([...nucDb]);
                    }
                });
            //}
        }
    }

    // Handle query sequence change with live duplicate checking
    const handleQuerySequenceChange = (e) => {
        formik.handleChange(e);

        // Check for duplicate sequence warning live
        const text = e.target.value;
        if (text && text.trim()) {
            const fastaResult = Validate.validateFastaInput(text);
            setDuplicateSeqWarning(fastaResult.warning || "");
        } else {
            setDuplicateSeqWarning("");
        }
        
        // Count sequences in real-time for mismatch display
        setQueryCount(countSequences(text));
    };

    function calTextCredits(e, bothDb, type) {
        //     if(type && type =="isCompare"){
        //     setIsBothDbSelected(!isBothDbSelected);
        // }
        let text;
        text = type && (type === "isCompare" || type === "redo") ? formik.values.querySequence : e.target.value;
        // For redo with subsequences, filter out generated _subseq_ entries so only
        // the original query sequences are counted for billing purposes.
        if (type === "redo" && useSubQuery && text) {
            const parts = text.split(/(?=>)/).filter(s => s.trim());
            const nonSubParts = parts.filter(s => !s.includes('_subseq_'));
            text = nonSubParts.join('');
        }
        // Check for duplicate sequence warning
        if (text && text.trim()) {
            const fastaResult = Validate.validateFastaInput(text);
            setDuplicateSeqWarning(fastaResult.warning || "");
        } else {
            setDuplicateSeqWarning("");
        }
        
        if ((e && (e.keyCode === 9 || e.type === "blur")) || type === "isCompare" || type === "redo") {
            /*if (ppuType === '0') {
                return;
            }*/
            // Count number of sequences and number of residues
            let val = 0;
            let nbResidues = 0;
            if (text !== undefined && text !== null && text.length > 0 && !text.startsWith('Paste your ')) {
                // Determine if FASTA/FASTAQ/Embl types, refer to SeqFileChecker.php
                // And then calculate the number of sequences
                let lines = text.split(/[\r\n]+/); // split by \n, \r and \r\n, and filter out empty lines
                if (/^\s*>\s*\S+/.test(text)) { // FASTA
                    // count > numbers
                    for (let i = 0; i < lines.length; i++) {
                        if (lines[i].substring(0, 1) === '>' && (i + 1) < lines.length && lines[i + 1].substring(0, 1) !== '>') {
                            val++;
                        }
                    }
                    if (val === 1 && lines.length > 1) {
                        nbResidues = lines[1].trim().length;
                    }
                } else if (/^\s*\@\s*\S+/.test(text)) { // FASTAQ
                    val = lines.length / 4;
                    if (val === 1 && lines.length > 1) {
                        nbResidues = lines[1].trim().length;
                    }
                } else if (/^[a-zA-Z0-9\.][a-zA-Z0-9\.][\s\t]/.test(text)) { // EMBL
                    // count '//' numbers
                    for (let i = 0; i < lines.length; i++) {
                        if (lines[i].substring(0, 2) === '//') {
                            val++;
                        }
                        // take lines start with space or start with 3+ consecutive letters.
                        if (/^[ \t]|^[a-zA-Z]{3,}/.test(lines[i])) {
                            nbResidues += lines[i].trim().length;
                        }
                    }
                } else {
                    // Appends ">seq_1\n" and treats as FASTA, refer to DlRawSeqdb.php
                    text = ">seq_1\n" + text;
                    lines = text.split(/[\r\n]+/);
                    // count > numbers
                    for (let i = 0; i < lines.length; i++) {
                        if (lines[i].substring(0, 1) === '>' && (i + 1) < lines.length && lines[i + 1].substring(0, 1) !== '>') {
                            val++;
                        }
                    }
                    if (val === 1 && lines.length > 1) {
                        nbResidues = lines[1].trim().length;
                    }
                }
            }
            creditValues.seqCount = val;
            creditValues.resCount = nbResidues;
            if (ppuType && ppuType === "1") {
                let ppu1SubTotal = val * 935;
                let ppu1NucSubTotal = (sequenceTypeValue === "nucleotide" || bothDb) ? val * 935 : 0;
                let ppu1ProSubTotal = (sequenceTypeValue === "protein" || bothDb) ? val * 935 : 0;
                //let subQueryTotal = useSubQuery ? Math.floor(subQueries.length / 5) * 935: 0; // each sub-query cos
                let ppu1Total = ppu1NucSubTotal + ppu1ProSubTotal;
                creditValues.ppu1SubTotal = ppu1SubTotal;
                creditValues.ppu1NucSubTotal = ppu1NucSubTotal;
                creditValues.ppu1ProSubTotal = ppu1ProSubTotal;
                creditValues.ppu1Total = ppu1Total;
                creditValues.seqCount = val;
                setCreditValues({ ...creditValues });
                setTimeout(() => {
                }, 2000);
            } else if (ppuType && ppuType === "2") {
                let ppu2NucCredit = (sequenceTypeValue === "nucleotide" || bothDb) ? val : 0;
                let ppu2ProCredit = (sequenceTypeValue === "protein" || bothDb) ? val : 0;
                //let subQueryTotal = useSubQuery ? Math.floor(subQueries.length / 5): 0; // each sub-query cos
                let ppu2TotalCredit = ppu2NucCredit + ppu2ProCredit;
                // factor in any voucher credits already entered so validation reflects effective balance
                let effectiveVoucher = Math.min(voucherCreditsToUse, ppu2TotalCredit);
                let ppu2RemainingCredits = credits - ppu2TotalCredit + effectiveVoucher;
                creditValues.ppu2NucCredit = ppu2NucCredit;
                creditValues.ppu2ProCredit = ppu2ProCredit;
                creditValues.ppu2TotalCredit = ppu2TotalCredit;
                creditValues.ppu2RemainingCredits = ppu2RemainingCredits;
                creditValues.seqCount = val;
                setCreditValues({ ...creditValues });
            } else {
                setCreditValues({ ...creditValues });
            }
        }
    }

    function setFormValue() {
        setSaveFormValue(!saveFormValue);
        if (!redoInitialState.formName) {
            formik.setFieldValue("formName", '');
        }
        setDefaultSave(false);
    }

    function homeRedirect() {
        history.push("/home");
    }

    const ColoredLine = ({ color, backgroundColor }) => (
        <hr
            style={{
                color: color,
                backgroundColor: backgroundColor || color,
                height: "0.5px"
            }}
        />
    );
    const docPublicSel = [
        {
            value: "BEF",
            label: "Before",
            id: "BEF"
        },
        {
            value: "BEF_IE",
            label: "Before or is empty",
            id: "BEF_IE"
        },
        {
            value: "AFT",
            label: "After",
            id: "AFT"
        },
        {
            value: "AFT_IE",
            label: "After or is empty",
            id: "AFT_IE"
        }
    ];
    const GQSpecificSel = [
        {
            value: "LTE",
            label: "is less than or equal to",
            id: "LTE"
        },
        {
            value: "LT",
            label: "is less than",
            id: "LT"
        },
        {
            value: "EQ",
            label: "equals",
            id: "EQ"
        },
        {
            value: "NEQ",
            label: "does not equal",
            id: "NEQ"
        },
        {
            value: "GT",
            label: "is greater than",
            id: "GT"
        },
        {
            value: "GTE",
            label: "is greater than or equal to",
            id: "GTE"
        }
    ];
    const searchAlgorithmItems = [
        {
            value: "kerr",
            label: "GenePast Search"
        },
        {
            value: "hash",
            label: "Gapless Search"
        },
        {
            value: "blast",
            label: "BLAST Search"
        },
        {
            value: "fragment",
            label: "Fragment Search"
        },
        {
            value: "motif",
            label: "MOTIF Search"
        }
    ];

    const genePastItems = [
        {
            value: "QUERY",
            label: "Query Sequence"
        },
        {
            value: "SUBJECT",
            label: "Subject Sequence"
        },
        {
            value: "SHORTER",
            label: "Query or Subject Sequence"
        }
    ];

    const nucleotideMatrixItems = [
        {
            value: "NUC.3.1",
            label: "NUC.3.1"
        },
        {
            value: "NUC.2.1",
            label: "NUC.2.1"
        },
        {
            value: "NUC.4.4",
            label: "NUC.4.4"
        }];
    const nucleotidewordSizeItems = [
        {
            value: "7",
            label: "7"
        },
        {
            value: "11",
            label: "11"
        },
        {
            value: "15",
            label: "15"
        }];

    const proteinMatrixItems = [
        {
            value: "BLOSUM62",
            label: "BLOSUM62"
        },
        {
            value: "PAM30",
            label: "PAM30"
        },
        {
            value: "PAM70",
            label: "PAM70"
        },
        {
            value: "BLOSUM80",
            label: "BLOSUM80"
        },
        {
            value: "BLOSUM45",
            label: "BLOSUM45"
        }
    ];
    const proteinwordSizeItems = [
        {
            value: "2",
            label: "2"
        },
        {
            value: "3",
            label: "3"
        }
    ];

    function changeIncludeGenUnknownDate() {
        if (!isDocPubUnknownDates) {
            formik.values.docPublicSel === "BEF" ? formik.setFieldValue("docPublicSel", "BEF_IE") : formik.values.docPublicSel === "AFT" ? formik.setFieldValue("docPublicSel", "AFT_IE") : formik.setFieldValue("docPublicSel", formik.values.docPublicSel)
        } //else {
            //formik.setFieldValue("docPublicSel", "BEF");
        //}
        setIsDocPubUnknownDates(!isDocPubUnknownDates);
    }
 

    function changeIncludeGQSpecificDate() {
        if (!ispublishGQUnknownDates) {
            formik.values.publishGQSel === "BEF" ? formik.setFieldValue("publishGQSel", "BEF_IE") : formik.values.publishGQSel === "AFT" ? formik.setFieldValue("publishGQSel", "AFT_IE") : formik.setFieldValue("publishGQSel", formik.values.publishGQSel)
        } //else {
            //formik.setFieldValue("publishGQSel", "BEF");
        //}
        setIspublishGQUnknownDates(!ispublishGQUnknownDates)
    }

    const beforeAfterSelection = (e) => {
        const { name, value } = e.target;
        formik.setFieldValue(name, value);
        if (name === "docPublicSel") {
            setIsDocPubDate(true);
            (value === "AFT" || value === "BEF") ? setIsDocPubUnknownDates(false) : setIsDocPubUnknownDates(true);
        } else if (name === "earliestPrioritySel") {
            setIsEarliestPriorityDate(true);
            (value === "AFT" || value === "BEF") ? setIsEarliestPriorityUnknownDates(false) : setIsEarliestPriorityUnknownDates(true);
        } else if (name === "publishGQSel") {
            setIsPublished(true);
            (value === "AFT" || value === "BEF") ? setIspublishGQUnknownDates(false) : setIspublishGQUnknownDates(true);
        }
    }

    const handleDocSel = (e) => {
        formik.handleChange(e);
        setIsPatientDoc(true);
    }

    let subjectText = "GenomeQuest: Error updating account information [Error code: " + errorMsg + "]";

    if (formSubmit && formik && formik.errors && Object.keys(formik.errors).length > 0) {
        let elem = document.getElementById(Object.keys(formik.errors)[0]);
        if (elem) {
            elem.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
        }
        setFromSubmit(false);
    }

    function submitForm() {
        formik.handleSubmit();
        setFromSubmit(true);
    }

    async function submitTempalte() {
        if (!formik.values.formName || formik.values.formName === '') {
            return;
        }
        if (isPatentAuth && (!selectedTags || selectedTags.length === 0)) {
            setNoPatentAuthValue(true);
            document.getElementById('isPatentAuth').scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
            return;
        }
        let values = formik.values;
        let sdbFilterData = [];
        if (isDocPubDate) {
            let docPubStatus;
            if (isDocPubUnknownDates && values.docPublicSel === "BEF") {
                docPubStatus = "BEF_IE";
            } else if (isDocPubUnknownDates && values.docPublicSel === "AFT") {
                docPubStatus = "AFT_IE";
            } else {
                docPubStatus = values.docPublicSel.toString();
            }
            let obj = {
                "P": "SEQUENCE_D1",
                "O": docPubStatus,
                "V": moment(values.docPublicDate).format('YYYYMMDD')
            }
            sdbFilterData.push(obj);
        }
        if (isEarliestPriorityDate) {
            let earliestPriorityStatus;
            if (isEarliestPriorityUnknownDates && values.earliestPrioritySel === "BEF") {
                earliestPriorityStatus = "BEF_IE";
            } else if (isEarliestPriorityUnknownDates && values.earliestPrioritySel === "AFT") {
                earliestPriorityStatus = "AFT_IE";
            } else {
                earliestPriorityStatus = values.earliestPrioritySel.toString();
            }
            let obj = {
                "P": "SEQUENCE_D4",
                "O": earliestPriorityStatus,
                "V": moment(values.earliestPriorityDate).format('YYYYMMDD')
            }
            sdbFilterData.push(obj);
        }
        if (isPublished) {
            let publishedStatus;
            if (ispublishGQUnknownDates && values.docPublicSel === "BEF") {
                publishedStatus = "BEF_IE";
            } else if (ispublishGQUnknownDates && values.docPublicSel === "AFT") {
                publishedStatus = "AFT_IE";
            } else {
                publishedStatus = values.publishGQSel.toString();
            }
            let obj = {
                "P": "SEQUENCE_D2",
                "O": publishedStatus,
                "V": moment(values.publishGQDate).format('YYYYMMDD')
            }
            sdbFilterData.push(obj);
        }
        if (isPatientDoc) {
            let obj = {
                "P": "SEQUENCE_P9",
                "O": values.patientDocSel.toString(),
                "V": values.patientDocInp
            }
            sdbFilterData.push(obj);
        }
        if (isPatentAuth) {

            const result = selectedTags.map(item => item + '*').join(',');
            let obj = {
                "P": "SEQUENCE_PN",
                "O": "CT",
                "V": result
            }
            sdbFilterData.push(obj);
        }
        let userMail = userInfo && userInfo.current_user && userInfo.current_user.email ? userInfo.current_user.email : '';
        let data = {
            qdb_seq: values.querySequence,
            qdb_seq_type: sequenceTypeValue, // nucleotide or protein, query sequence type based on the above query seq.
            qdb_id: "", // will have such value for virtual query database, not included in this release yet
            searchtype: "FTO", // leave it as always "FTO"
            title: values.searchDetails.trim(), // Workflow name
            email: sendMailAfterSearch ? userMail : '', // When "Send email when the search is done" is checked, retrieve the email from the user info
            send_email: sendMailAfterSearch ? "on" : "",
            nucandprot: isBothDbSelected ? "on" : "", // "on" when selecting both NUC and PRO databases
            strat_name: searchAlgorithmValue, // Genepast -> kerr, Blast -> blast, Fragment Search -> fragment, Motif -> motif
            frame_sel: currentSelectedValue,
            seqlenrange_low: values.minResidues, // Limit subject length from
            seqlenrange_high: values.maxResidues, // Limit subject length to
            best_hit_keep_max: values.alignments, // Keep a maximum of xxx results
            sdb_filters: sdbFilterData && sdbFilterData.length > 0 ? JSON.stringify(sdbFilterData) : "",
            nucdb_type: "multiple", // always multiple
            nucdbs: nucDb,
            // nucdbs: "[\"p:GQPAT_NUC\", \"p:GENA\"]", // string array of databases
            protdb_type: "multiple", // always multiple
            protdbs: proDb, // Similar like nucdbs
            template_name: saveFormValue ? values.formName.trim() : '', // Set this value when selecting "Save this form for later use as"
            is_default: defaultsave,
            parent_id: "", // When having the patent workflow, for the "redo" scenario
            match_tu: matchTu ? "1" : "0",
            bypass_ft: createFt,
            voucher_credits: voucherCreditsToUse
            //ignore_warning: isWarningReturned ? "1" : "",
        };
        if (searchAlgorithmValue === "kerr" || searchAlgorithmValue === "hash") {
            // Genepast parameters
            data.strat_genepast_perc_id = values.genePastPercentage;
            data.strat_genepast_perc_id_over = values.genepastPercentageOver;
        } else if (searchAlgorithmValue === "blast") {
            // Blast
            data.strat_blast_word_size_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? wordSizeValue : "11"; // Word Size - Nucleotide
            data.strat_blast_scoring_matrix_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? scoringMatrixValue : "NUC.3.1"; // Scoring matrix - Nucleotide
            data.strat_blast_word_size_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? wordSizeValue : "3"; // Word Size - Protein
            data.strat_blast_scoring_matrix_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? scoringMatrixValue : "BLOSUM62"; // Scoring matrix - Protein
            data.strat_blast_eval_cutoff = values.expectCutoff; // Expect Cutoff
            data.strat_blast_hsp = processHsp ? "on" : ""; // HSP handling, "on" when the checkbox is selected
        } else if (searchAlgorithmValue === "fragment") {
            // Fragment
            data.strat_fragment_window_length_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? values.fragmentStretch : "50"; // Window Length - Nuc
            data.strat_fragment_perc_id_nuc = sequenceTypeValue && sequenceTypeValue === "nucleotide" ? values.fragmentAminoAcid : "96"; // Percentage Identity - Nuc
            data.strat_fragment_window_length_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? values.fragmentStretch : "20"; // Window Length - Prt
            data.strat_fragment_perc_id_pro = sequenceTypeValue && sequenceTypeValue === "protein" ? values.fragmentAminoAcid : "95"; // Percentage Identity - Prt
        } else if (searchAlgorithmValue === "motif") {
            // Set the qdb_seq_type to be nucpat/propat
            if (data.qdb_seq_type === "nucleotide") {
                data.qdb_seq_type = "nucpat";
            } else {
                data.qdb_seq_type = "propat";
            }
        }

        await saveTemplate(data, null);
        window.location.reload();
    }

    const handleDocCheck = (e) => {
        const { name } = e.target;
        if (name && name === "isDocumentPublic") {
            if (isDocPubDate === true) {
                setIsDocPubUnknownDates(false);
            }
            setIsDocPubDate(prevState => !prevState)
        } else if (name && name === "isEarliestPriority") {
            if (isEarliestPriorityDate === true) {
                setIsEarliestPriorityUnknownDates(false);
            }
            setIsEarliestPriorityDate(prevState => !prevState)
        } else if (name && name === "publishGenomeQuest") {
            if (isPublished === true) {
                setIspublishGQUnknownDates(false);
            }
            setIsPublished(prevState => !prevState);
        }
    }


    const saveSelectedPA = async(selectedtagss) => {
        setSelectedTags(selectedtagss);
        if(selectedtagss.length === 0){
            setIsPatentAuth(false);
            setNoPatentAuthValue(false);
        }else {setIsPatentAuth(true); setNoPatentAuthValue(false); }
    }

    const handleAuthorityTypingStart = () => {
        setIsPatentAuth(true);
        setNoPatentAuthValue(false);
    }

    const handleTuChange = () => {
        setMatchTu(!matchTu);
        if (matchTu) { // Unselected
            setFrameType("for"); // When Tu mismatched, only forward mode is supported
        } else {
            setFrameType("both"); // When Tu matched, set to both again
        }
    }

    const handleFrameChange = (event) => {
        setFrameType(event.target.value);
      };

    const currentSelectedValue = isBothDbSelected || sequenceTypeValue === "protein" ? "both" : frameTypeValue; // Default to 'option1' when disabled


    const [stretchLength, setStretchLength] = useState(12);
    const [queryCount, setQueryCount] = useState(0);
    const [subQueryError, setSubQueryError] = useState("");
    const [subQuerySearchError, setSubQuerySearchError] = useState("");

    function createSubQueryName(name, subQueryIndex) {
        return name + "_subseq_" + subQueryIndex+"\n";
    }

    // Wrapper functions using shared mismatch calculator
    const getMaxMismatches = () => calculateMaxMismatches(
        formik.values.querySequence, 
        formik.values.genePastPercentage
    );

    const shouldShowMismatch = () => checkMismatchDisplay(
        formik.values.querySequence,
        queryCount,
        searchAlgorithmValue,
        formik.values.genepastPercentageOver,
        formik.values.genePastPercentage
    );

    useEffect(() => {
        if(!parentId){
            HandleSubQuery(formik.values.querySequence);
        }
    }, [useSubQuery, formik.values.querySequence, stretchLength]);
    
    function HandleSubQuery(val) {

        if(!useSubQuery || formik.values.querySequence.trim() === ""){
            setSubQueries([]);
            return;
        }
        if(!stretchLength || stretchLength < 6){
            setSubQueryError("Stretch length must be greater than 5");
            setSubQueries([]);
            return
        }else{
            setSubQueryError("");
        }

        let test = val.trim().split(/[\n\r,]+/);

        let  names = test.filter(function (el) {
            return el != null && el !== "" && (el.startsWith(">"));
        });

        //remove all empty items
        let  Seqs = test.filter(function (el) {
            return el != null && el !== "" && (!el.startsWith(">"));
        });

        if(Seqs.length > 1){
            setSubQuerySearchError("Cannot search multiple Sequences with Sub-Queries.");
            return;
        }else{
            setSubQuerySearchError("");
        }

        //get longest sequence length
        let maxLen = 0;
        for(let i=0; i<Seqs.length; i++){
            let seqLen = Seqs[i].replaceAll(/[\s\d]/g, "").length;
            if(seqLen > maxLen){
                maxLen = seqLen;
            }
        }

        if(stretchLength > maxLen){
            setSubQueryError("Stretch length cannot be greater than the longest sequence length: "+maxLen);
            return;
        }else{
            setSubQueryError("");
        }

        if(names.length !== Seqs.length){

            //insert "" in 0 of names to make lengths equal
            names.unshift(">Seq_1");
        }

        setQueryCount(Seqs.length); // this should not be here but it works for now

        let subQueryArr = [];
        for(let i=0; i<Seqs.length; i++){

            //remove the name from line
            Seqs[i] = Seqs[i].replaceAll(/[\s\d]/g, "");

            for(let j=0; j< Seqs[i].length - parseInt(stretchLength)+1; j++){
                let name = createSubQueryName(names[i], j+1);
                let subSeq = Seqs[i].substring(j, j + parseInt(stretchLength))+"\n";
                subQueryArr.push(name+subSeq);
            }
        }
        setSubQueries(subQueryArr);
        console.log(formik.values.querySequence+'\n'+subQueryArr.toString().replaceAll(/[,]+/g, ""));
        
    }

    return (
       
        <div className={classes.grow}> 
            <SeqVIModal
                show={showSuccessModal}
                onMessage={t('searchSubmitted')}
                type="seqSearch"
                saveCallBack={closeSaveModal}
            />
            <ContactSupportErrorModal
                show={showErrorModal}
                errorCode={errorMsg}
                modalCallBack={handleErrorModal}
                subjectText={subjectText}
                errorContent={errorHeading}
                isWarning={isWarningReturned}
                type="editSearch" // When clicking cancel button, only close the modal dialog
            />
            {userInfo.current_user.user_class_id !== 12 &&
            <form name="ipSequenceSearchForm">
                <Row>
                    <Col lg="12" md="12" sm='12' className={"mb-2 " + (!systemControlSubmit ? 'd-block' : 'd-none')}>
                        <Typography className="text-danger">
                            {t('ABsearchDisableText')}
                            {systemControlSubmitText}
                            {t('patienceThanksText')}
                        </Typography>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12" md="12" xs='12'>
                        <p className="subHeading w-50 mb-10 float-left">{t('searchDetails')}</p>
                        <span style={{float: 'right'}}>
                        <DropDownBox
                            margin="normal"
                            variant="outlined"
                            name={"preferences"}
                            id={"preferences"}
                            value={preferenceValue}
                            items={preferenceItems}
                            onChange={handlePreference}
                            label={"IP search templates"}
                        />&nbsp;
                        <a className={"appLink"} href={`${process.env.PUBLIC_URL}/docs/index.html?s=ip_sequence_searching`}
                           target="_blank" rel="noreferrer" >{t('help')}</a></span >
                    </Col>
                </Row>
                <Row>
                    <Col md="6" xs="6" sm='6'>
                        {/* <p className="subHeading">{t('searchDetails')}</p> */}
                        <div className="form-group">
                            <TextInput spellCheck="false"
                                fullWidth
                                id="searchDetails"
                                name="searchDetails"
                                label={t('nameYourSearch')}
                                variant="outlined"
                                value={formik.values.searchDetails ? formik.values.searchDetails : ""}
                                onChange={formik.handleChange}
                                error={formik.touched.searchDetails && Boolean(formik.errors.searchDetails)}
                                helperText={formik.touched.searchDetails && formik.errors.searchDetails}
                            />
                        </div>
                    </Col>
                </Row>
                <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                {/* <Row>
                    <Col lg="12" md="12" className={"mb-2 " + (isWarningReturned ? 'd-block' : 'd-none')}>
                    <Typography className="text-danger">
                    Please notice the warnings below and either fix it or submit as is.
                        </Typography>
                    <Typography className="text-danger">
                        {warningMsg}
                        </Typography>
                    </Col>
                </Row> */}
                {parentId &&
                    <Fragment>
                        <Row>
                            <Col sm="12" md="12">
                                <p className="subHeading w-75 mb-10 float-left">{t('queryPreloaded')}</p>
                            </Col>
                        </Row>
                        <p className="bodyText">
                            {t('redoAlertText')}
                        </p>
                    </Fragment>
                }
                {!parentId &&
                    <Fragment>
                        <Row>
                            <Col sm="12" md="12" xs='12'>
                                <p className="subHeading w-75 mb-10 float-left">{t('querySequences')}</p>
                                <a className={"appTextFont appLink float-right"} href={`${process.env.PUBLIC_URL}/docs/index.html?s=ip_sequence_searching&a=querysequenceinput`} target="_blank" rel="noreferrer">{t('help')}</a>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12" md="10">
                                <div className="form-group">
                                    <TextInput spellcheck="false"
                                        rowsMax="8"
                                        rows="8"
                                        multiline={true}
                                        fullWidth
                                        id="querySequence"
                                        name="querySequence"
                                        label={t('querySequencesPlaceHolder')}
                                        variant="outlined"
                                        value={formik.values.querySequence ? formik.values.querySequence : ""}
                                        onChange={handleQuerySequenceChange}
                                        error={formik.touched.querySequence && formik.errors.querySequence || subQuerySearchError !== ""}
                                        helperText={formik.errors.querySequence || subQuerySearchError}
                                        //onKeyDown={(e) => calTextCredits(e, isBothDbSelected, null)}
                                        onKeyDown={handleppuCredits}
                                        onBlur={(e) => calTextCredits(e, isBothDbSelected, null)}
                                    />
                                    {duplicateSeqWarning && (
                                        <Typography >
                                            <span style={{ color: '#f44336', fontSize: '12px', marginTop: '4px'}}>WARNING: </span> 
                                            <span style={{ fontSize: '0.75rem', marginTop: '4px',fontFamily: "Roboto, Helvetica, Arial, sans-serif",fontStyle: "italic" }}>{duplicateSeqWarning}</span>
                                        </Typography>
                                    )}
                                </div>
                            </Col>
                            <Col md="2"></Col>
                        </Row>
                        <Row>
                            <Col md="9" xs="9" sm='9'>
                                <FormControl component="fieldset">
                                    <RadioGroup row aria-label="These are" name="customized-radios" value={sequenceTypeValue} onChange={handleSequenceType}>
                                        <span className={classes.theseAreText + " bodyText"}>{t("theseAre")}</span>
                                        <FormControlLabel value="nucleotide" control={<RadioButton />} label="Nucleotide Sequences" className="bodyText" />
                                        <FormControlLabel value="protein" control={<RadioButton />} label="Protein Sequences" />
                                    </RadioGroup>
                                </FormControl>
                            </Col>
                            <div style={{marginLeft: "10px"}}>
                                <div style={{display: "flex", alignItems: "center"}}>
                                <CheckBox
                                    checked={useSubQuery}
                                    onChange={(e) => {
                                        setUseSubQuery(e.target.checked);

                                        handleSearchAlgorithm({target: {value: e.target.checked ? 'hash' : 'kerr'}});
                                        handleCompareBothDb(true);
                                    }}
                                    disabled={isBothDbSelected}
                                    color="primary"
                                    className={"bodyText"}
                                    name="subQ"
                                />
                                <span className={"bodyText"}>Search for stretches of contiguous residues</span>
                                </div>
                                {useSubQuery &&
                                <div>
                                    <div style={{ paddingTop: "10px", display: "flex", alignItems: "center"}}>
                                        <span className={"bodyText"} style={{marginLeft: "30px", paddingRight: "10px"}} >Stretch Length</span>
                                        <CustomTooltip arrow title={subQueryError} placement="bottom">
                                        <TextInput
                                            value={stretchLength}
                                            onChange={(e) => {
                                                let val = e.target.value;
                                                //replace any non-numeric character
                                                val = val.replace(/\D/g, '');
                                                setStretchLength(val);
                                            }}
                                            error={subQueryError !== ""}
                                            variant="outlined"
                                            className={classes.smallTextBox}
                                        />
                                        </CustomTooltip>
                                        <Typography className={classes.seqText} style={{ paddingLeft: "10px", fontStyle: 'italic', fontSize: '0.85rem' }}>
                                            ({subQueries.length} Subsequences)
                                        </Typography>
                                    </div>
                                    <p style={{padding:"12px 0 0 30px", width: "700px", fontSize: "8pt", color: "lightgrey", opacity: 0.8}}>
                                        By Selecting this option your query sequence(s) will be split into overlapping sub-sequences of the chosen length.
                                        For a 15 residue sequence with a stretch length of 10, six sub-sequences (1-10 through 6-15) will be generated.
                                        The search will use the gapless algorithm.
                                    </p>
                                </div>
                                }
                            </div>
                        </Row>
                    </Fragment>
                }
                <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                <Row>
                    <Col sm="12" md="12">
                        <p className="subHeading w-75 mb-10 float-left">{t('searchAlgorithmAndSetting')}</p>
                        <a className={"appTextFont appLink float-right"} href={`${process.env.PUBLIC_URL}/docs/index.html?s=sequence_comparison_algorithms&a=searchstrategy`} target="_blank" rel="noreferrer">{t('help')}</a>
                    </Col>
                </Row>
                {parentId &&
                <Row>
                    <AccordionDetails>
                        <Col md="12" xs="12" sm='12'>
                            <SelectBox
                                margin="normal"
                                variant="outlined"
                                name="searchType"
                                id="searchType"
                                value={searchAlgorithmValue}
                                items={selData}
                                onChange={handleSearchAlgorithm}
                                disabled={useSubQuery} // Disable when using sub-query
                                className={"float-left"}
                            />
                            {searchAlgorithmValue && (searchAlgorithmValue === 'kerr' || searchAlgorithmValue === 'hash') && <Fragment>
                                <Typography className={"float-left " + classes.seqText} style={{ marginLeft: '10px' }}>
                                    {t("findAtleast")}&nbsp;&nbsp;&nbsp;
                                </Typography>
                                <TextInput
                                    fullWidth={false}
                                    id="genePastPercentage"
                                    name="genePastPercentage"
                                    label={''}
                                    variant="outlined"
                                    className={classes.smallTextBox + " float-left"}
                                    value={formik.values.genePastPercentage}
                                    onChange={handleDecimalInput(formik.handleChange)}
                                    error={formik.touched.genePastPercentage && Boolean(formik.errors.genePastPercentage)}
                                    helperText={formik.touched.genePastPercentage && formik.errors.genePastPercentage}
                                />
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;% {t("identityOver")} &nbsp;&nbsp;
                                </Typography>
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="genepastPercentageOver"
                                    id="genepastPercentageOver"
                                    value={formik.values.genepastPercentageOver}
                                    items={genePastItems}
                                    onChange={formik.handleChange}
                                    className={"float-left bodyText"}
                                    style={{backgroundColor: '#292929'}}
                                />
                                {shouldShowMismatch() && (
                                    <Typography className={"float-left " + classes.seqText} style={{ marginLeft: '10px', fontStyle: 'italic', fontSize: '0.85rem' }}>
                                        (up to {getMaxMismatches()} mismatches allowed)
                                    </Typography>
                                )}
                            </Fragment>
                            }
                            {searchAlgorithmValue && searchAlgorithmValue === 'blast' && <Fragment>
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;{t("scoringMatrix")}&nbsp;&nbsp;&nbsp;
                                </Typography>
                                {sequenceTypeValue === 'nucleotide' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="scoringMatrix"
                                    id="scoringMatrix"
                                    value={scoringMatrixValue}
                                    items={nucleotideMatrixItems}
                                    className={"float-left"}
                                    onChange={e => setScoringMatrix(e.target.value)}
                                />
                                }
                                {sequenceTypeValue === 'protein' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="scoringMatrix"
                                    id="scoringMatrix"
                                    value={scoringMatrixValue}
                                    items={proteinMatrixItems}
                                    className={"float-left"}
                                    onChange={e => setScoringMatrix(e.target.value)}
                                />
                                }
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;{t("wordSize")} &nbsp;&nbsp;
                                </Typography>
                                {sequenceTypeValue === 'nucleotide' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="wordSize"
                                    id="wordSize"
                                    value={wordSizeValue}
                                    items={nucleotidewordSizeItems}
                                    className={"float-left " + classes.smallTextBox}
                                    onChange={e => setWordSize(e.target.value)}
                                />
                                }
                                {sequenceTypeValue === 'protein' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="wordSize"
                                    id="wordSize"
                                    value={wordSizeValue}
                                    items={proteinwordSizeItems}
                                    className={"float-left " + classes.smallTextBox}
                                    onChange={e => setWordSize(e.target.value)}
                                />
                                }
                                <div className={classes.blastMargin}>
                                    <Typography className={"float-left " + classes.seqText}>
                                        &nbsp;&nbsp;{t("expectCutOff")}&nbsp;&nbsp;&nbsp;
                                    </Typography>
                                    <TextInput
                                        fullWidth={false}
                                        id="expectCutoff"
                                        name="expectCutoff"
                                        label={''}
                                        variant="outlined"
                                        className={classes.smallTextBox + ' float-left'}
                                        value={formik.values.expectCutoff}
                                        onChange={formik.handleChange}
                                        error={formik.touched.expectCutoff && Boolean(formik.errors.expectCutoff)}
                                        helperText={formik.touched.expectCutoff && formik.errors.expectCutoff}
                                    />
                                    <CheckBox
                                        color="primary"
                                        className={"float-left ml-20 " + classes.processHsps}
                                        name="processHsps"
                                        id="processHsps"
                                        onChange={() => setProcessHsp(!processHsp)}
                                        checked={processHsp}
                                    />
                                    <Typography className={"float-left mt-2"}>
                                        {t("processHsps")} &nbsp;&nbsp;&nbsp;
                                    </Typography>
                                </div>
                            </Fragment>
                            }
                            {searchAlgorithmValue && searchAlgorithmValue === 'fragment' && <Fragment>
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;{t("findStretchAtLeast")}&nbsp;&nbsp;&nbsp;
                                </Typography>
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentStretch"
                                    name="fragmentStretch"
                                    label={''}
                                    variant="outlined"
                                    className={classes.smallTextBox + ' float-left'}
                                    value={formik.values.fragmentStretch}
                                    onChange={formik.handleChange}
                                    error={formik.touched.fragmentStretch && Boolean(formik.errors.fragmentStretch)}
                                    helperText={formik.touched.fragmentStretch && formik.errors.fragmentStretch}
                                />
                                {sequenceTypeValue && sequenceTypeValue === "protein" && <Typography className={"float-left mt-2"}>
                                    &nbsp;&nbsp;{t("aminoAcidWith")} &nbsp;&nbsp;
                                </Typography>}
                                {sequenceTypeValue && sequenceTypeValue === "nucleotide" && <Typography className={"float-left mt-2"}>
                                    &nbsp;&nbsp;{t("nucleotidesWith")} &nbsp;&nbsp;
                                </Typography>}
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentAminoAcid"
                                    name="fragmentAminoAcid"
                                    label={''}
                                    variant="outlined"
                                    className={classes.smallTextBox + ' float-left'}
                                    value={formik.values.fragmentAminoAcid}
                                    onChange={handleDecimalInput(formik.handleChange)}
                                    error={formik.touched.fragmentAminoAcid && Boolean(formik.errors.fragmentAminoAcid)}
                                    helperText={formik.touched.fragmentAminoAcid && formik.errors.fragmentAminoAcid}
                                />
                                <Typography className={"float-left mt-2"}>
                                    &nbsp;&nbsp;% {t("identityOrMore")}
                                </Typography>
                            </Fragment>
                            }
                            {searchAlgorithmValue && searchAlgorithmValue === 'motif' && <Fragment>
                                <a className={"float-left " + classes.seqText}
                                   href={`${process.env.PUBLIC_URL}/docs/index.html?s=sequence_comparison_algorithms&a=motif`}
                                   target="_blank" rel="noreferrer">
                                    &nbsp;&nbsp;{t("examplesOfValidMotif")}
                                </a>
                            </Fragment>
                            }
                        </Col>
                    </AccordionDetails>
                </Row>
                }
                {!parentId &&
                <Row>
                    <AccordionDetails>
                        <Col md="12" xs="12" sm='12'>
                            <SelectBox
                                margin="normal"
                                variant="outlined"
                                name="searchType"
                                id="searchType"
                                value={searchAlgorithmValue}
                                items={searchAlgorithmItems}
                                onChange={handleSearchAlgorithm}
                                className={"float-left"}
                            />
                            {searchAlgorithmValue && (searchAlgorithmValue === 'kerr' || searchAlgorithmValue === 'hash') && <Fragment>
                                <Typography className={"float-left " + classes.seqText} style={{ marginLeft: '10px' }}>
                                    {t("findAtleast")}&nbsp;&nbsp;&nbsp;
                                </Typography>
                                <TextInput
                                    fullWidth={false}
                                    id="genePastPercentage"
                                    name="genePastPercentage"
                                    label={''}
                                    variant="outlined"
                                    className={classes.smallTextBox + " float-left"}
                                    value={formik.values.genePastPercentage}
                                    onChange={handleDecimalInput(formik.handleChange)}
                                    error={formik.touched.genePastPercentage && Boolean(formik.errors.genePastPercentage)}
                                    helperText={formik.touched.genePastPercentage && formik.errors.genePastPercentage}
                                />
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;% {t("identityOver")} &nbsp;&nbsp;
                                </Typography>
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="genepastPercentageOver"
                                    id="genepastPercentageOver"
                                    value={formik.values.genepastPercentageOver}
                                    items={genePastItems}
                                    onChange={formik.handleChange}
                                    className={"float-left bodyText"}
                                />
                                {shouldShowMismatch() && (
                                    <Typography className={"float-left " + classes.seqText} style={{ marginLeft: '10px', fontStyle: 'italic', fontSize: '0.85rem' }}>
                                        (up to {getMaxMismatches()} mismatches allowed)
                                    </Typography>
                                )}
                            </Fragment>
                            }
                            {searchAlgorithmValue && searchAlgorithmValue === 'blast' && <Fragment>
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;{t("scoringMatrix")}&nbsp;&nbsp;&nbsp;
                                </Typography>
                                {sequenceTypeValue === 'nucleotide' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="scoringMatrix"
                                    id="scoringMatrix"
                                    value={scoringMatrixValue}
                                    items={nucleotideMatrixItems}
                                    className={"float-left"}
                                    onChange={e => setScoringMatrix(e.target.value)}
                                />
                                }
                                {sequenceTypeValue === 'protein' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="scoringMatrix"
                                    id="scoringMatrix"
                                    value={scoringMatrixValue}
                                    items={proteinMatrixItems}
                                    className={"float-left"}
                                    onChange={e => setScoringMatrix(e.target.value)}
                                />
                                }
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;{t("wordSize")} &nbsp;&nbsp;
                                </Typography>
                                {sequenceTypeValue === 'nucleotide' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="wordSize"
                                    id="wordSize"
                                    value={wordSizeValue}
                                    items={nucleotidewordSizeItems}
                                    className={"float-left " + classes.smallTextBox}
                                    onChange={e => setWordSize(e.target.value)}
                                />
                                }
                                {sequenceTypeValue === 'protein' && <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    name="wordSize"
                                    id="wordSize"
                                    value={wordSizeValue}
                                    items={proteinwordSizeItems}
                                    className={"float-left " + classes.smallTextBox}
                                    onChange={e => setWordSize(e.target.value)}
                                />
                                }
                                <div className={classes.blastMargin}>
                                    <Typography className={"float-left " + classes.seqText}>
                                        &nbsp;&nbsp;{t("expectCutOff")}&nbsp;&nbsp;&nbsp;
                                    </Typography>
                                    <TextInput
                                        fullWidth={false}
                                        id="expectCutoff"
                                        name="expectCutoff"
                                        label={''}
                                        variant="outlined"
                                        className={classes.smallTextBox + ' float-left'}
                                        value={formik.values.expectCutoff}
                                        onChange={formik.handleChange}
                                        error={formik.touched.expectCutoff && Boolean(formik.errors.expectCutoff)}
                                        helperText={formik.touched.expectCutoff && formik.errors.expectCutoff}
                                    />
                                    <CheckBox
                                        color="primary"
                                        className={"float-left ml-20 " + classes.processHsps}
                                        name="processHsps"
                                        id="processHsps"
                                        onChange={() => setProcessHsp(!processHsp)}
                                        checked={processHsp}
                                    />
                                    <Typography className={"float-left mt-2"}>
                                        {t("processHsps")} &nbsp;&nbsp;&nbsp;
                                    </Typography>
                                </div>
                            </Fragment>
                            }
                            {searchAlgorithmValue && searchAlgorithmValue === 'fragment' && <Fragment>
                                <Typography className={"float-left " + classes.seqText}>
                                    &nbsp;&nbsp;{t("findStretchAtLeast")}&nbsp;&nbsp;&nbsp;
                                </Typography>
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentStretch"
                                    name="fragmentStretch"
                                    label={''}
                                    variant="outlined"
                                    className={classes.smallTextBox + ' float-left'}
                                    value={formik.values.fragmentStretch}
                                    onChange={formik.handleChange}
                                    error={formik.touched.fragmentStretch && Boolean(formik.errors.fragmentStretch)}
                                    helperText={formik.touched.fragmentStretch && formik.errors.fragmentStretch}
                                />
                                {sequenceTypeValue && sequenceTypeValue === "protein" && <Typography className={"float-left mt-2"}>
                                    &nbsp;&nbsp;{t("aminoAcidWith")} &nbsp;&nbsp;
                                </Typography>}
                                {sequenceTypeValue && sequenceTypeValue === "nucleotide" && <Typography className={"float-left mt-2"}>
                                    &nbsp;&nbsp;{t("nucleotidesWith")} &nbsp;&nbsp;
                                </Typography>}
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentAminoAcid"
                                    name="fragmentAminoAcid"
                                    label={''}
                                    variant="outlined"
                                    className={classes.smallTextBox + ' float-left'}
                                    value={formik.values.fragmentAminoAcid}
                                    onChange={handleDecimalInput(formik.handleChange)}
                                    error={formik.touched.fragmentAminoAcid && Boolean(formik.errors.fragmentAminoAcid)}
                                    helperText={formik.touched.fragmentAminoAcid && formik.errors.fragmentAminoAcid}
                                />
                                <Typography className={"float-left mt-2"}>
                                    &nbsp;&nbsp;% {t("identityOrMore")}
                                </Typography>
                            </Fragment>
                            }
                            {searchAlgorithmValue && searchAlgorithmValue === 'motif' && <Fragment>
                                <a className={"float-left " + classes.seqText}
                                   href={`${process.env.PUBLIC_URL}/docs/index.html?s=sequence_comparison_algorithms&a=motif`}
                                   target="_blank" rel="noreferrer">
                                    &nbsp;&nbsp;{t("examplesOfValidMotif")}
                                </a>
                            </Fragment>
                            }
                        </Col>
                    </AccordionDetails>
                </Row>
                }
                <Row>
                    <AccordionDetails className="appTextColor">
                        <Col md="12" style={{ paddingLeft: '5px', marginTop: '10px' }}>
                            <CheckBox
                                color="primary"
                                className={"float-left"}
                                name="compareboth"
                                id="compareboth"
                                disabled={useSubQuery || (searchAlgorithmValue && searchAlgorithmValue === 'motif')}
                                onChange={handleCompareBothDb}
                                checked={isBothDbSelected}
                            // onChange={() => calTextCredits("isCompare")}
                            />
                            <label className={classes.checkBoxContent + " bodyText ml-0" + (searchAlgorithmValue !== 'motif' ? " cursorPointer" : "")} htmlFor="compareboth">{t("compareBothNucPro")}</label>
                        </Col>
                    </AccordionDetails>
                </Row>
                { (!isBothDbSelected && sequenceTypeValue && sequenceTypeValue === "nucleotide" && (searchAlgorithmValue === "kerr" || searchAlgorithmValue === "hash")) &&
                    <Row>
                        <AccordionDetails className="appTextColor">
                        <Col md="12" style={{ paddingLeft: '5px', marginTop: '10px' }}>
                            <CheckBox
                                // defaultChecked
                                color="primary"
                                className={"float-left"}
                                name="matchTu"
                                id="matchTu"
                                onChange={ handleTuChange }
                                checked={matchTu}
                            />
                            <label className={classes.checkBoxContent + " bodyText ml-0 cursorPointer"} htmlFor="matchTu">{t("matchTu")}</label>
                        </Col>
                        </AccordionDetails>
                    </Row>
                }
                <Row>
                    
                        <Col md="9" xs="9" sm='9'>
                            {!(isBothDbSelected || sequenceTypeValue === "protein" || searchAlgorithmValue === "blast") &&
                            <FormControl component="fieldset" disabled= {isBothDbSelected || sequenceTypeValue === "protein"  || ((searchAlgorithmValue === "kerr" || searchAlgorithmValue === "hash") && !matchTu)}>
                                <RadioGroup row aria-label="These are" name="customized-radios" value={currentSelectedValue} onChange={handleFrameChange} >
                                    <span className={classes.theseAreText + " bodyText"}>Alignment Frame Selection: </span>
                                    <FormControlLabel value="both" control={<RadioButton />} label="Both " className="bodyText" />
                                    <FormControlLabel value="for" control={<RadioButton />} label="Forward " />
                                    <FormControlLabel value="rev" control={<RadioButton />} label="Reverse " />
                                </RadioGroup>
                             </FormControl>}
                        </Col>
                </Row>
                <Row>
                    <AccordionDetails className="appTextColor" style={{ marginLeft: '-5px' }}>
                        <Col md="12">
                            <Typography className={"float-left " + classes.seqText}>
                                {t("Report")}&nbsp;&nbsp;&nbsp;
                            </Typography>
                            <TextInput
                                fullWidth={false}
                                id="alignments"
                                name="alignments"
                                label={''}
                                variant="outlined"
                                value={formik.values.alignments}
                                onChange={formik.handleChange}
                                error={formik.touched.alignments && Boolean(formik.errors.alignments)}
                                helperText={formik.touched.alignments && formik.errors.alignments}
                                className={"float-left "}
                            />
                            <Typography className={"float-left " + classes.seqText}>
                                &nbsp;&nbsp;{t("bestAlignmentsPerQuerySeq")}&nbsp;&nbsp;
                            </Typography>
                        </Col>
                    </AccordionDetails>
                </Row>
                <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                <Row>
                    <Col md="12">
                        <a href={`${process.env.PUBLIC_URL}/docs/index.html?s=ip_sequence_searching&a=subjectdbselection`} target="_blank" className="appTextFont appLink float-right" rel="noreferrer">{t("help")}</a>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <Accordion square expanded={seqDBFilter} onChange={() => setSeqDBFilter(prevState => !prevState)}>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" className="subHeading p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                <p className="subHeading m-0">
                                    {seqDBFilter && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!seqDBFilter && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className={classes.arrowIconTitle}>{t("generalSeqDbFilter")}</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                <Col md="12" sm='12' xs='12' className={classes.row1}>
                                    <Typography className={"float-left " + classes.seqText} style={{ width: '350px' }}>
                                        {t("searchOnlySeqBetween")}&nbsp;&nbsp;
                                    </Typography>
                                    <TextInput
                                        fullWidth={false}
                                        id="minResidues"
                                        name="minResidues"
                                        // label={6}
                                        variant="outlined"
                                        value={formik.values.minResidues}
                                        onChange={formik.handleChange}
                                        error={formik.touched.minResidues && Boolean(formik.errors.minResidues)}
                                        helperText={formik.touched.minResidues && formik.errors.minResidues}
                                        className={"float-left " + classes.numberInput}
                                    />
                                    <Typography className={"float-left " + classes.seqText}>
                                        &nbsp;&nbsp;{t("to")}&nbsp;&nbsp;
                                    </Typography>
                                    <TextInput
                                        fullWidth={false}
                                        id="maxResidues"
                                        name="maxResidues"
                                        // label={maxResidues}
                                        variant="outlined"
                                        value={formik.values.maxResidues}
                                        onChange={formik.handleChange}
                                        error={formik.touched.maxResidues && Boolean(formik.errors.maxResidues)}
                                        helperText={formik.touched.maxResidues && formik.errors.maxResidues}
                                        className={"float-left " + classes.numberInput}
                                    />
                                    <Typography className={"float-left " + classes.seqText} style={{ marginLeft: '10px' }}>
                                        {t("residuesInLength")}
                                    </Typography>
                                </Col>
                                {/* <br clear="all"></br> */}
                                {/* <br clear="all"></br> */}
                                <Col md="12" sm='12' xs='12' className={(toggle? classes.rowElementsContainer: classes.rowElementsContainerDark)} >
                                    <div style={{ width: '230px', display: 'flex' }}>
                                        <CheckBox
                                            color="primary"
                                            className={"float-left"}
                                            name="isDocumentPublic"
                                            id="isDocumentPublic"
                                            // onChange={() => setIsDocPubDate(!isDocPubDate)}
                                            onChange={handleDocCheck}
                                            checked={isDocPubDate}
                                        />
                                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-0 mr-2"} htmlFor="isDocumentPublic">{t("docPublicationDate")}</label>
                                    </div>
                                    <SelectBox
                                        margin="normal"
                                        variant="outlined"
                                        name="docPublicSel"
                                        id="docPublicSel"
                                        value={formik.values.docPublicSel}
                                        onChange={beforeAfterSelection}
                                        items={docPublicSel}
                                        className={"float-left"}
                                       // disabled={isDocPubDate ? false : true}
                                    />
                                    <DatePicker
                                        margin="normal"
                                        id="docPublicDate"
                                        name="docPublicDate"
                                        dateFormat="MMMM-d-yyyy"
                                        label="Date picker inline"
                                        value={formik.values.docPublicDate}
                                        inputVariant="outlined"
                                        className={toggle ? "float-left ml-4 bodyText": "float-left ml-4"}
                                        style={{color: '#292929'}}
                                        onChange={val => {
                                            formik.setFieldValue("docPublicDate", val);
                                            setIsDocPubDate(true);
                                        }}
                                        //disabled={isDocPubDate ? false : true}
                                    />
                                </Col>
                                <Col md="12" sm='12' xs='12' className={(toggle? classes.rowElementsContainer: classes.rowElementsContainerDark)}>
                                     <div style={{ width: '250px', display: 'flex' }}>
                                        <CheckBox
                                            color="primary"
                                            className={"float-left"}
                                            name="isPatentAuth"
                                            id="isPatentAuth"
                                            onChange={() => { setIsPatentAuth(!isPatentAuth); setNoPatentAuthValue(false); }}
                                            checked={isPatentAuth}
                                        />
                                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-0 mr-3"} htmlFor="isPatentAuth">{t("patentAuthorityOnly")}</label>
                                    </div>

                                    <AuthoritySearch
                                    actionModal = {saveSelectedPA}
                                    isPatentAuth={isPatentAuth}
                                    redoPA = {redoPA}
                                    itemV = {itemV}
                                    hasError = {noPatentAuthValue}
                                    onStartTyping = {handleAuthorityTypingStart}/>
                                    {noPatentAuthValue && <p className={"ManualError"} id="noPatentAuthValue">You must enter at least one valid Patent Authority</p>}
                                </Col>
                            </AccordionDetails>
                        </Accordion>
                    </Col>
                    {/* <Col md="1" className={classes.desktopHelpLink}>
                        <a href={`${process.env.PUBLIC_URL}/docs/index.html?s=ip_sequence_searching&a=subjectdbselection`} target="_blank" className="appTextFont appLink float-right mr-2" rel="noreferrer">{t("help")}</a>
                    </Col> */}
                    <Col md="12">
                        <Accordion square expanded={specificDBFilter} onChange={() => setSpecificDBFilter(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" className="subHeading p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                <p className="subHeading m-0">
                                    {specificDBFilter && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!specificDBFilter && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className={classes.arrowIconTitle}>{t("GQPatSpecificDbFilters")}</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails >
                                <Col md="12" sm='12' xs='12' className={(toggle? classes.rowElementsContainer: classes.rowElementsContainerDark)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <div style={{ width: '230px', display: 'flex' }}>
                                        <CheckBox
                                            color="primary"
                                            className={"float-left"}
                                            name="publishGenomeQuest"
                                            id="publishGenomeQuest"
                                            // onChange={() => setIsPublished(!isPublished)}
                                            onChange={handleDocCheck}
                                            checked={isPublished}
                                        />
                                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-0 mr-3"} htmlFor="publishGenomeQuest">{t("publishedInGenomeQuest")}</label>
                                    </div>
                                    <SelectBox
                                        margin="normal"
                                        variant="outlined"
                                        name="publishGQSel"
                                        id="publishGQSel"
                                        value={formik.values.publishGQSel}
                                        onChange={beforeAfterSelection}
                                        items={docPublicSel}
                                        className={"float-left"}
                                        //disabled={isPublished ? false : true}
                                    />
                                    <DatePicker
                                        margin="normal"
                                        id="publishGQDate"
                                        name="publishGQDate"
                                        dateFormat="MMMM-d-yyyy"
                                        value={formik.values.publishGQDate}
                                        inputVariant="outlined"
                                        className={toggle ? "float-left ml-4 bodyText": "float-left ml-4"}
                                        allowKeyboardControl={false}
                                        onChange={val => {
                                            formik.setFieldValue("publishGQDate", val);
                                            setIsPublished(true);
                                        }}
                                        //disabled={isPublished ? false : true}
                                        disablePast={false}
                                    />
                                </Col>
                                {/* <br clear="all"></br> */}
                                {/* <br clear="all"></br> */}
                                <Col md="12" sm='12' xs='12' className={(toggle? classes.rowElementsContainer: classes.rowElementsContainerDark)} >
                                    <div style={{ width: '230px', display: 'flex' }}>
                                        <CheckBox
                                            color="primary"
                                            className={"float-left"}
                                            name="isEarliestPriority"
                                            id="isEarliestPriority"
                                            onChange={handleDocCheck}
                                            checked={isEarliestPriorityDate}
                                        />
                                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-0 mr-2"} htmlFor="isEarliestPriority">{t("earliestPriorityDate")}</label>
                                    </div>
                                    <SelectBox
                                        margin="normal"
                                        variant="outlined"
                                        name="earliestPrioritySel"
                                        id="earliestPrioritySel"
                                        value={formik.values.earliestPrioritySel}
                                        onChange={beforeAfterSelection}
                                        items={docPublicSel}
                                        className={"float-left"}
                                    />
                                    <DatePicker
                                        margin="normal"
                                        id="earliestPriorityDate"
                                        name="earliestPriorityDate"
                                        dateFormat="MMMM-d-yyyy"
                                        label="Date picker inline"
                                        value={formik.values.earliestPriorityDate}
                                        inputVariant="outlined"
                                        className={toggle ? "float-left ml-4 bodyText": "float-left ml-4"}
                                        style={{color: '#292929'}}
                                        onChange={val => {
                                            formik.setFieldValue("earliestPriorityDate", val);
                                            setIsEarliestPriorityDate(true);
                                        }}
                                        allowKeyboardControl={false}
                                        disablePast={false}
                                    />
                                </Col>
                                <Col md="12" sm='12' xs='12' className={(toggle? classes.rowElementsContainer: classes.rowElementsContainerDark)}>
                                    <div style={{ width: '230px', display: 'flex' }}>
                                        <CheckBox
                                            color="primary"
                                            className={"float-left"}
                                            name="isPatientDoc"
                                            id="isPatientDoc"
                                            onChange={() => setIsPatientDoc(!isPatientDoc)}
                                            checked={isPatientDoc}
                                        />
                                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-0 mr-3"} htmlFor="isPatientDoc">{t("patentDocContains")}</label>
                                    </div>
                                    <SelectBox
                                        margin="normal"
                                        variant="outlined"
                                        name="patientDocSel"
                                        id="patientDocSel"
                                        value={formik.values.patientDocSel}
                                        onChange={handleDocSel}
                                        items={GQSpecificSel}
                                        className={"float-left"}
                                        //disabled={isPatientDoc ? false : true}
                                    />
                                    <TextInput
                                        fullWidth={false}
                                        id="patientDocInp"
                                        name="patientDocInp"
                                        // label={maxResidues}
                                        variant="outlined"
                                        value={formik.values.patientDocInp}
                                        onChange={handleDocSel}
                                        error={formik.touched.patientDocInp && Boolean(formik.errors.patientDocInp)}
                                        helperText={isPatientDoc && formik.touched.patientDocInp && formik.errors.patientDocInp}
                                        className={"float-left mx-4 " + classes.numberInput}
                                        //disabled={isPatientDoc ? false : true}
                                    />
                                    <Typography className={"float-left mt-2"}>
                                        {(t("sequences"))}
                                    </Typography>
                                </Col>
                               
                            </AccordionDetails>
                        </Accordion>
                    </Col>
                   
                    {/* <Col md="12" className={classes.mobileHelpLink}>
                        <Link className="appTextFont appLink float-right">{t("help")}</Link>
                    </Col> */}
                </Row>
                {/* <ColoredLine color="black" /> */}
                <hr style={toggle ? {backgroundColor: '#dfdfdf'}: {backgroundColor: '#aea9a9'}}/>
                <div>
                    <Row>
                        <Col sm="12" md="12" xs='12'>
                            <a href={`${process.env.PUBLIC_URL}/docs/index.html?s=ip_sequence_searching&a=subjectdbselection`} target="_blank" className="appTextFont appLink float-right" rel="noreferrer">{t("help")}</a>
                        </Col>
                    </Row>
                    {noDbSelected && <p className={"ManualError"} id="noDbSelected"> You must select at least one subject database</p>}
                    <Row>
                        <Col md="6" xs="6" sm='6'>
                            {nucPatentData && _.size(nucPatentData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && proDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck1} onChange={() => setformCheck1(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="subHeading p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck1 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck1 && <ArrowRightIcon className={classes.arrowIcon} />}

                                            <span className={classes.arrowIconTitle}>{t("nucPatentDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>                                            {nucPatentData.map((test, index) => (
                                        <div className="relativePosition"
                                            key={index}
                                            style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }
                                        >
                                            <CheckBox
                                                name="nuc"
                                                id={test.id}
                                                checked={nucDb.includes(test.id)}
                                                onChange={e => handleDbChange(e.target.id, e.target.name)}
                                                className={"absolutePosition " + classes.checkBox}
                                                disabled={useSubQuery && sequenceTypeValue === "protein" ? true : false}
                                                color="primary"
                                                style={{ color: (toggle ? '': '#aea9a9' )}}
                                            />
                                            <label className={classes.checkBoxContent + " bodyText cursorPointer"} htmlFor={test.id}>{test.label}</label>
                                        </div>
                                    ))
                                    }
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {nucReferenceData && _.size(nucReferenceData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && proDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck3} onChange={() => setformCheck3(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck3 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck3 && <ArrowRightIcon className={classes.arrowIcon} />}

                                            <span className={classes.arrowIconTitle}>{t("referenceNucDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {nucReferenceData.map((test, index) => (
                                            <div className="relativePosition"
                                                key={index}
                                            >
                                                <Checkbox
                                                    name="nuc"
                                                    id={test.id}
                                                    checked={nucDb.includes(test.id)}
                                                    onChange={e => handleDbChange(e.target.id, e.target.name)}
                                                    className={"absolutePosition " + classes.checkBox}
                                                    color="primary"
                                                    disabled={useSubQuery && sequenceTypeValue === "protein" ? true : false}
                                                    style={{ color: (toggle ? '': '#aea9a9' )}}
                                                />
                                                <label className={classes.checkBoxContent + " bodyText cursorPointer"} htmlFor={test.id}>{test.label}</label>
                                            </div>
                                        ))
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {nucGenBankData && _.size(nucGenBankData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && proDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck5} onChange={() => setformCheck5(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0">
                                        <p className="subHeading m-0">
                                            {formCheck5 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck5 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("genBankNucDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {nucGenBankData.map((test, index) => (
                                            <div className="relativePosition"
                                                key={index}
                                                style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }
                                            >
                                                <Checkbox
                                                    name="nuc"
                                                    id={test.id}
                                                    checked={nucDb.includes(test.id)}
                                                    onChange={e => handleDbChange(e.target.id, e.target.name)}
                                                    className={"absolutePosition " + classes.checkBox}
                                                    color="primary"
                                                    style={{ color: (toggle ? '': '#aea9a9' )}}
                                                />
                                                <label className={classes.checkBoxContent + " bodyText cursorPointer"} htmlFor={test.id}>{test.label}</label>
                                            </div>
                                        ))
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {nucPersonalData && _.size(nucPersonalData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && proDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck7} onChange={() => setformCheck7(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck7 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck7 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("personalNucDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <FolderTreeStructure expandedIds={expandedNucIds} treeData={nucPersonalData} parentCallBack={handleDbChange} dbName="nuc" dataArray={nucDb} seQValue={sequenceTypeValue === "nucleotide" ? "nuc" : "pro"} pageType="ipseq" />
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {nucSharedData && _.size(nucSharedData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && proDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck9} onChange={() => setformCheck9(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck9 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck9 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("sharedNucDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <FolderTreeStructure expandedIds={expandedNucSharedIds} treeData={nucSharedData} parentCallBack={handleDbChange} dbName="nuc" dataArray={nucDb} seQValue={sequenceTypeValue === "nucleotide" ? "nuc" : "pro"} pageType="ipseq" />
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                        </Col>
                        <Col md="6" xs="6" sm='6'>
                            {proPatentData && _.size(proPatentData) > 0 && 
                                 (ppuType !='2' || (ppuType === '2' && !(parentId && nucDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck2} onChange={() => setformCheck2(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck2 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck2 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("proteinPatDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {proPatentData.map((test, index) => (
                                            <div className="relativePosition"
                                                key={index}
                                                style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }
                                            >
                                                <Checkbox
                                                    name="pro"
                                                    id={test.id}
                                                    checked={proDb.includes(test.id)}
                                                    onChange={e => handleDbChange(e.target.id, e.target.name)}
                                                    className={"absolutePosition " + classes.checkBox}
                                                    color="primary"
                                                    disabled={useSubQuery && sequenceTypeValue === "nucleotide" ? true : false}
                                                    style={{ color: (toggle ? '': '#aea9a9' )}}
                                                />
                                                <label className={classes.checkBoxContent + " bodyText cursorPointer"} htmlFor={test.id}>{test.label}</label>
                                            </div>
                                        ))
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {proReferenceData && _.size(proReferenceData) > 0 && 
                            (ppuType !='2' || (ppuType === '2' && !(parentId && nucDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) &&<div>
                                <Accordion expanded={formCheck4} onChange={() => setformCheck4(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck4 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck4 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("referenceProDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {proReferenceData.map((test, index) => (
                                            <div className="relativePosition"
                                                key={index}
                                                style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }
                                            >
                                                <Checkbox
                                                    name="pro"
                                                    id={test.id}
                                                    checked={proDb.includes(test.id)}
                                                    onChange={e => handleDbChange(e.target.id, e.target.name)}
                                                    className={"absolutePosition " + classes.checkBox}
                                                    color="primary"
                                                    disabled={useSubQuery && sequenceTypeValue === "nucleotide" ? true : false}
                                                    style={{ color: (toggle ? '': '#aea9a9' )}}
                                                />
                                                <label className={classes.checkBoxContent + " bodyText cursorPointer"} htmlFor={test.id}>{test.label}</label>
                                            </div>
                                        ))
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {proPersonalData && _.size(proPersonalData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && nucDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck6} onChange={() => setformCheck6(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck6 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck6 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("personalProDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <FolderTreeStructure expandedIds={expandedPrtIds} treeData={proPersonalData} parentCallBack={handleDbChange} dbName="pro" dataArray={proDb} seQValue={sequenceTypeValue === "nucleotide" ? "nuc" : "pro"} pageType="ipseq" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} } />
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                            {proSharedData && _.size(proSharedData) > 0 && 
                             (ppuType !='2' || (ppuType === '2' && !(parentId && nucDb.length > 0)) || (ppuType === '2' && isBothDbSelected) ) && <div>
                                <Accordion expanded={formCheck8} onChange={() => setformCheck8(prevState => !prevState)} style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                    <AccordionSummary aria-controls="panel1c-content" id="panel1c-header" className="p-0" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} }>
                                        <p className="subHeading m-0">
                                            {formCheck8 && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                            {!formCheck8 && <ArrowRightIcon className={classes.arrowIcon} />}
                                            <span className={classes.arrowIconTitle}>{t("sharedProDb")}</span>
                                        </p>
                                    </AccordionSummary>
                                    <AccordionDetails >
                                        <FolderTreeStructure expandedIds={expandedPrtSharedIds} treeData={proSharedData} parentCallBack={handleDbChange} dbName="pro" dataArray={proDb} seQValue={sequenceTypeValue === "nucleotide" ? "nuc" : "pro"} pageType="ipseq" style={toggle ? {backgroundColor: '#ffffff'}: {backgroundColor: '#292929'} } />
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            }
                        </Col>
                    </Row>
                </div>
                {showCreditCalC &&
                    <Fragment>
                        <ColoredLine color="#f3f2f2" />
                        <Row>
                            <Col md="11" xs="11" sm='11'>
                                <p className="subHeading">Search Fee</p>
                                {groupVoucherCredits > 0 && (
                                    <div className="d-flex align-items-center mb-2" style={{ gap: '8px' }}>
                                        <span className="bodyText">Use</span>
                                        <TextInput
                                            type="number"
                                            variant="outlined"
                                            inputProps={{ min: 0, max: maxVoucherCredits }}
                                            value={voucherCreditsToUse}
                                            onChange={(e) => setVoucherCreditsToUse(Math.min(Math.max(0, Number(e.target.value)), maxVoucherCredits))}
                                            style={{ width: '80px' }}
                                            InputProps={{ style: { borderRadius: '7px', border: '2px solid #337AB7' } }}
                                        />
                                        <span className="bodyText">of my <strong>{groupVoucherCredits}</strong> available voucher credits</span>
                                    </div>
                                )}
                                {ppuType === "1" && <p>{t('executingSearchCharges')}</p>}
                                {ppuType === "2" && <p>{t('executingSearchCredits')}</p>}
                                <table className="ml-5">
                                    {ppuType === "1" && <Fragment>
                                        <tr>
                                            <td><p>${creditValues.ppu1SubTotal}</p></td>
                                            <td><p className="ml-3">{creditValues.seqCount} {t('amountPerSeq')} </p></td>
                                        </tr>
                                        {useSubQuery && 
                                            <tr>
                                                <td><p>${Math.floor(subQueries.length / 5) * 935 }</p></td>
                                                <td><p className="ml-3">{subQueries.length} sub-query sequences @ $935.00 for every complete set of 5</p></td>
                                            </tr>
                                        }
                                        <tr>
                                            <td><p>${creditValues.ppu1NucSubTotal + (useSubQuery && sequenceTypeValue == "nucleotide" ?  Math.floor(subQueries.length / 5) * 935 : 0)}</p></td>
                                            <td><p className="ml-3">{t('nucSubTotal')}</p></td>
                                        </tr>
                                        <tr>
                                            <td><p>${creditValues.ppu1ProSubTotal + (useSubQuery && sequenceTypeValue == "protein" ?  Math.floor(subQueries.length / 5) * 935 : 0)}</p></td>
                                            <td><p className="ml-3">{t('proSubTotal')}</p></td>
                                        </tr>
                                        {voucherCreditsToUse > 0 && (
                                            <tr>
                                                <td><p>-${voucherCreditsToUse * 935}</p></td>
                                                <td><p className="ml-3">{t("voucherDiscount")} ({voucherCreditsToUse} {t("credits")})</p></td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>
                                                <p className="subHeading">${creditValues.ppu1Total + (useSubQuery ? Math.floor(subQueries.length / 5) * 935 : 0) - voucherCreditsToUse * 935}</p>
                                            </td>
                                            <td>
                                                <p className="ml-3 subHeading">{t('total')}</p>
                                            </td>
                                        </tr>
                                    </Fragment>
                                    }
                                    {ppuType === "2" && <Fragment>
                                        <tr>
                                            <td><p>1</p></td>
                                            <td><p className="ml-3">{t('creditsPerSeq')} {useSubQuery &&  <span>and every complete set of 5 sub-sequences</span>}</p></td>
                                        </tr>
                                        <tr>
                                            <td><p>{creditValues.seqCount}</p></td>
                                            <td><p className="ml-3">{t('noOfQueryInSearch')}</p></td>
                                        </tr>
                                        {useSubQuery &&
                                        <tr>
                                            <td><p>{Math.floor(subQueries.length / 5)}</p></td>
                                            <td><p className="ml-3">Total number of sub-sequences (sets of 5)</p></td>
                                        </tr>
                                        }
                                        <tr>
                                            <td><p>{creditValues.ppu2NucCredit + (useSubQuery && sequenceTypeValue == "nucleotide" ?  Math.floor(subQueries.length / 5) : 0)}</p></td>
                                            <td><p className="ml-3">{t('nucCreditSubTotal')}</p></td>
                                        </tr>
                                        <tr>
                                            <td><p>{creditValues.ppu2ProCredit + (useSubQuery && sequenceTypeValue == "protein" ?  Math.floor(subQueries.length / 5) : 0)}</p></td>
                                            <td><p className="ml-3">{t('proCreditSubTotal')}</p></td>
                                        </tr>

                                        {voucherCreditsToUse > 0 && (
                                            <tr>
                                                <td><p>-{voucherCreditsToUse}</p></td>
                                                <td><p className="ml-3">{t("voucherCreditsApplied")}</p></td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>
                                                <p className="subHeading">{creditValues.ppu2TotalCredit + Math.floor(subQueries.length / 5) - voucherCreditsToUse}</p>
                                            </td>
                                            <td>
                                                <p className="ml-3 subHeading">{t('totalCredits')}</p>
                                            </td>
                                        </tr>
                                        <tr className="subHeading">
                                            <td>
                                                <p className="subHeading">{creditValues.ppu2RemainingCredits - Math.floor(subQueries.length / 5)}</p>
                                            </td>
                                            <td>
                                                <p className="ml-3 subHeading">{t('creditsRemaining')}</p>
                                            </td>
                                        </tr>
                                    </Fragment>
                                    }
                                </table>
                            </Col>
                            {/*<Col md="1" xs="1" sm='1'>
                                <Link className="appTextFont appLink float-right">{t("help")}</Link>
                                </Col> */}
                        </Row>
                        {ppuType !== "0" && <Row>
                            <Col md="12" xs="12" sm='12' style={{ paddingLeft: '10px' }}>
                                <CheckBox
                                    // defaultChecked
                                    color="primary"
                                    className={"float-left"}
                                    name="checkTerms"
                                    id="checkTerms"
                                    onChange={() => { setIsSubmitActive(!isSubmitActive) }}
                                    //onChange={handleppuCredits}
                                    checked={isSubmitActive}
                                    style={{ color: (toggle ? '': '#aea9a9' )}}
                                />
                                <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-0 mr-3"} htmlFor="checkTerms">{t("acceptTermsCheckBox")}</label>
                            </Col>
                        </Row>
                        }
                    </Fragment>
                }
                <ColoredLine color="#f3f2f2" />
                <Row>
                    <Col md="12" style={{ paddingLeft: '10px' }}>
                        <CustomTooltip arrow title="Skip Discover text indexing to speed up the search, especially when searching for more than 100,000 alignments" placement="top">
                        <span>
                        <CheckBox
                            // defaultChecked
                            color="primary"
                            className={"float-left"}
                            name="createFt"
                            id="createFt"
                            onChange={() => { setCreateFt(!createFt) }}
                            checked={createFt}
                        />
                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-2 mr-3"} htmlFor="createFt">{t("createFt")}</label>
                         </span></CustomTooltip>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" xs="12" sm='12' style={{ paddingLeft: '10px' }}>
                        <CheckBox
                            // defaultChecked
                            color="primary"
                            className={"float-left"}
                            name="check"
                            id="check"
                            onChange={() => { setSendMailAfterSearch(!sendMailAfterSearch) }}
                            checked={sendMailAfterSearch}
                        />
                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-2 mr-3"} htmlFor="check">{t("sendMailAfterSearch")}</label>
                    </Col>
                </Row>
                <Row>
                    <Col md='4' xs="4" sm='4' style={{ paddingLeft: '10px' }}>
                        <CheckBox
                            // defaultChecked
                            color="primary"
                            className={"float-left"}
                            name="saveForm"
                            id="saveForm"
                            onChange={setFormValue}
                            checked={saveFormValue}
                        />
                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-2 mr-3"} htmlFor="saveForm">{t("SaveFormForlaterUse")}</label>
                    </Col>
                    <Col md='6' xs="6" sm='6' style={{ marginLeft: '-80px' }}>
                        <TextInput
                            spellCheck="false"
                            id="formName"
                            name="formName"
                            label="Name the form"
                            variant="outlined"
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value.length <= 48) {
                                    formik.setFieldValue("formName", value);
                                    formik.setFieldError("formName", "");
                                } else {
                                    formik.setFieldError(
                                        "formName",
                                        "Maximum 48 characters allowed"
                                    );
                                }
                            }}
                            fullWidth={true}
                            disabled={!saveFormValue}
                            value={formik.values.formName || ""}
                            error={saveFormValue && Boolean(formik.errors.formName)}
                            helperText={saveFormValue && formik.errors.formName}
                        />
                    </Col>
                    <Col md="2" xs="2" sm="2" style={{ paddingLeft: "10px" }}>
                        {saveFormValue ? (
                            <Button className="accountInfo float-left" onClick={submitTempalte}>
                                {t("saveTemplate")}
                            </Button>
                        ) : (
                            <Button className="cancelButtonDisable float-left" disabled>
                                {t("saveTemplate")}
                            </Button>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col md="12" xs="12" sm='12' style={{ paddingLeft: '10px' }}>
                        <CheckBox
                            // defaultChecked
                            color="primary" 
                            className={
                                toggle
                                    ? "float-left"
                                    :`float-left ${
                                        !saveFormValue ? classes.checkboxDisabled : classes.checkboxEnabled
                                }`
                            }
                            name="checkDefault"
                            id="checkDefault"
                            onChange={() => { setDefaultSave(!defaultsave) }}
                            checked={defaultsave}
                            disabled={!saveFormValue}
                            style={{ color: (toggle ? '': '#aea9a9' )}}
                        />
                        <label className={classes.checkBoxContent + " bodyText cursorPointer float-left ml-2 mr-3"} htmlFor="checkDefault" disabled={!saveFormValue}>
                            {t("defaultsave")}</label>
                    </Col>
                </Row>
                <br></br>
                <Row >
                    <Col  >
                        {(isSubmitActive && subQueryError === "" && subQuerySearchError === "") && <Button className="accountInfo" onClick={submitForm}>
                            {t("submit")}
                        </Button>}
                        {(!isSubmitActive || subQueryError !== "" || subQuerySearchError !== "") && <Button className="cancelButtonDisable" disabled>
                            {t("submit")}
                        </Button>}
                        <Button className={classes.loginSubmitCancel} onClick={homeRedirect}>
                            {t("cancel")}
                        </Button>
                    </Col>
                </Row>
                {/* <FormikErrorFocus
            // See scroll-to-element for configuration options: https://www.npmjs.com/package/scroll-to-element
            offset={0}
            align={'top'}
            focusDelay={200}
            ease={'linear'}
            duration={1000}
          /> */}
            </form>}
        </div> 
    );
}

export default IpSeqSearch;
